// Empresas.js - VERSÃO CORRIGIDA COM TAB SISTEMA REORGANIZADA
// 🔥 TAB SISTEMA - CORES PRÉ-DEFINIDAS, SEM COR SECUNDÁRIA, SEM COLOR PICKER
// 🔥 MESMO ESTILO QUE O DEFINICOES.JS
// 🔥 LOCALIZAÇÃO REMOVIDA - APENAS TEMA DO SISTEMA
// 🔥 FIX: CRIAÇÃO DE EMPRESA SEM ASSOCIAR UTILIZADOR AUTOMATICAMENTE
// 🔥 FIX: SUPERADMIN não mostra toggle nem botão de remover
// 🔥 FIX: SCROLL INTERNO NO MODAL (footer sempre fixo no fundo)

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './Empresas.css';
import { Icon } from './SharedComponents';

// ==============================================
// FUNÇÃO AUXILIAR PARA CONVERTER CHECKBOXES
// ==============================================
const processFormData = (data) => {
    const processed = { ...data };

    if (processed.configuracoes?.modulosAtivos) {
        const modulos = processed.configuracoes.modulosAtivos;
        const modulosProcessados = {};

        const estruturaModulos = {
            dashboard: {
                ativo: true,
                submodulos: {
                    overview: true,
                    estatisticas: true,
                    atividades_recentes: true,
                    graficos: true
                }
            },
            vendas: {
                ativo: true,
                submodulos: {
                    dashboard_vendas: true,
                    faturas: true,
                    cotacoes: true,
                    recibos: true,
                    guias_entrega: true,
                    recebimentos: true,
                    relatorios_vendas: true,
                    configuracoes_vendas: true
                }
            },
            comercial: {
                ativo: true,
                submodulos: {
                    clientes: true,
                    fornecedores: true
                }
            },
            stock: {
                ativo: true,
                submodulos: {
                    produtos: true,
                    criar_produto: true,
                    servicos: true,
                    entrada_stock: true,
                    categorias: true,
                    movimentos: true,
                    inventario: true,
                    armazens: true
                }
            },
            analise: {
                ativo: true,
                submodulos: {
                    analitico: true,
                    relatorios: true,
                    financeiro: true
                }
            },
            admin: {
                ativo: false,
                submodulos: {
                    utilizadores: true,
                    empresas: false,
                    licencas: false,
                    logs: false,
                    definicoes: true
                }
            }
        };

        Object.keys(estruturaModulos).forEach(moduloId => {
            const moduloExistente = modulos[moduloId];
            const estruturaBase = estruturaModulos[moduloId];

            if (!moduloExistente) {
                modulosProcessados[moduloId] = {
                    ativo: estruturaBase.ativo,
                    submodulos: { ...estruturaBase.submodulos }
                };
                return;
            }

            if (typeof moduloExistente === 'boolean') {
                modulosProcessados[moduloId] = {
                    ativo: moduloExistente,
                    submodulos: { ...estruturaBase.submodulos }
                };
                return;
            }

            if (typeof moduloExistente === 'object') {
                const ativo = moduloExistente.ativo !== undefined ? moduloExistente.ativo : estruturaBase.ativo;
                const submodulos = {};
                Object.keys(estruturaBase.submodulos).forEach(subId => {
                    submodulos[subId] = moduloExistente.submodulos?.[subId] !== undefined
                        ? moduloExistente.submodulos[subId]
                        : estruturaBase.submodulos[subId];
                });
                modulosProcessados[moduloId] = {
                    ativo: ativo,
                    submodulos: submodulos
                };
                return;
            }

            modulosProcessados[moduloId] = {
                ativo: estruturaBase.ativo,
                submodulos: { ...estruturaBase.submodulos }
            };
        });

        processed.configuracoes.modulosAtivos = modulosProcessados;
    }

    if (processed.arquivado !== undefined) {
        processed.arquivado = processed.arquivado === 'on' || processed.arquivado === true;
    }

    if (processed.retencaoFonte !== undefined) {
        processed.retencaoFonte = processed.retencaoFonte === 'on' || processed.retencaoFonte === true;
    }

    if (processed.setorActividade === '') processed.setorActividade = null;
    if (processed.ramoAtividade === '') processed.ramoAtividade = null;
    if (!processed.regimeIVA || processed.regimeIVA === '') processed.regimeIVA = 'Normal';
    if (!processed.status || processed.status === '') processed.status = 'EmAprovacao';
    if (processed.morada?.pais === '') processed.morada.pais = 'Moçambique';
    if (processed.plano?.tipo === '') processed.plano.tipo = 'Trial';

    if (processed.cafe === undefined) processed.cafe = '';

    if (processed.percentagemIVA === undefined || processed.percentagemIVA === null || processed.percentagemIVA === '') {
        processed.percentagemIVA = 16;
    } else {
        processed.percentagemIVA = Number(processed.percentagemIVA);
    }

    if (processed.dadosBancarios && Array.isArray(processed.dadosBancarios)) {
        processed.dadosBancarios = processed.dadosBancarios.filter(b =>
            b.banco || b.conta || b.nib || b.swift || b.titular
        );
    }

    return processed;
};

// ==============================================
// COMPONENTES DE IMAGEM
// ==============================================
const EmpresaImage = ({ empresa, getImagemUrl }) => {
    const [imageError, setImageError] = useState(false);

    if (!empresa.imagemPerfil || imageError) {
        return (
            <div className="empresa-logo-placeholder-mini">
                <Icon name="apartment" size={20} />
            </div>
        );
    }

    return (
        <img
            src={getImagemUrl(empresa.imagemPerfil)}
            alt={empresa.nome}
            className="empresa-logo-mini"
            onError={() => setImageError(true)}
        />
    );
};

const UserAvatar = ({ user, getImagemUrl }) => {
    const [imageError, setImageError] = useState(false);

    if (!user.imagemPerfil || imageError) {
        return (
            <div className="user-avatar-placeholder">
                <Icon name="person" size={32} />
            </div>
        );
    }

    return (
        <img
            src={getImagemUrl(user.imagemPerfil)}
            alt={user.nome}
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%', display: 'block' }}
            onError={() => setImageError(true)}
        />
    );
};

export default function Empresas() {
    const [empresas, setEmpresas] = useState([]);
    const [filteredEmpresas, setFilteredEmpresas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [empresaToDelete, setEmpresaToDelete] = useState(null);
    const [message, setMessage] = useState({ text: '', type: '' });
    const [uploadingImage, setUploadingImage] = useState(false);
    const fileInputRef = useRef(null);
    const editFileInputRef = useRef(null);
    const [activeModalTab, setActiveModalTab] = useState('geral');
    const [filtroStatus, setFiltroStatus] = useState('todos');
    const [filtroPlano, setFiltroPlano] = useState('todos');
    const [pagination, setPagination] = useState({ page: 1, limit: 9, total: 0, pages: 0 });
    const [isSuperadmin, setIsSuperadmin] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [tempImagePreview, setTempImagePreview] = useState(null);

    const [createLoading, setCreateLoading] = useState(false);
    const [createMessage, setCreateMessage] = useState({ text: '', type: '' });

    const [editLoading, setEditLoading] = useState(false);
    const [editMessage, setEditMessage] = useState({ text: '', type: '' });

    // ==============================================
    // ESTADOS PARA GESTÃO DE UTILIZADORES
    // ==============================================
    const [showUsersModal, setShowUsersModal] = useState(false);
    const [empresaUsers, setEmpresaUsers] = useState([]);
    const [availableUsers, setAvailableUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [selectedUserToAdd, setSelectedUserToAdd] = useState('');
    const [usersModalMessage, setUsersModalMessage] = useState({ text: '', type: '' });

    const [showConfirmRemoveUserModal, setShowConfirmRemoveUserModal] = useState(false);
    const [userToRemove, setUserToRemove] = useState(null);
    const [removingUser, setRemovingUser] = useState(false);

    const [showSuperAdminWarningModal, setShowSuperAdminWarningModal] = useState(false);
    const [superAdminToRemove, setSuperAdminToRemove] = useState(null);
    const [isLastSuperAdmin, setIsLastSuperAdmin] = useState(false);

    // ==============================================
    // ESTADOS PARA GESTÃO DE LICENÇAS
    // ==============================================
    const [licencaData, setLicencaData] = useState(null);
    const [loadingLicenca, setLoadingLicenca] = useState(false);
    const [isEditingLicenca, setIsEditingLicenca] = useState(false);
    const [editLicencaData, setEditLicencaData] = useState({
        chave: '',
        tipoPrazo: 'Mensal',
        dataFim: '',
        plano: 'Basico',
        limiteUtilizadores: 5,
        limiteProdutos: 100,
        ativa: true
    });
    const [licencaMessage, setLicencaMessage] = useState({ text: '', type: '' });

    // ==============================================
    // ESTADOS PARA LIMITE DE UTILIZADORES
    // ==============================================
    const [limiteUtilizadores, setLimiteUtilizadores] = useState({ limite: 0, utilizadoresAtuais: 0, disponivel: 0 });
    const [loadingLimite, setLoadingLimite] = useState(false);

    // ==============================================
    // FUNÇÃO AUXILIAR PARA VERIFICAR SE É SUPERADMIN
    // ==============================================
    const isUserSuperAdmin = (user) => {
        if (!user) return false;
        const isSuper =
            user.perfil === 'Superadmin' ||
            user.perfil === 'superadmin' ||
            user.perfil === 'SuperAdmin' ||
            user.isSuperadmin === true ||
            user.isSuperadmin === 'true' ||
            user.role === 'Superadmin' ||
            user.role === 'superadmin' ||
            user.role === 'SuperAdmin' ||
            user.tipo === 'Superadmin' ||
            user.tipo === 'superadmin';

        return isSuper;
    };

    // ==============================================
    // FUNÇÃO PARA CALCULAR BRILHO DA COR
    // ==============================================
    const calcularBrilho = (cor) => {
        if (!cor) return 0;
        let hex = cor.replace('#', '');
        if (hex.length === 3) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return (r * 299 + g * 587 + b * 114) / 1000;
    };

    // ==============================================
    // 🔥 CORES PRÉ-DEFINIDAS (INCLUINDO BRANCO) - MESMO DO DEFINICOES
    // ==============================================
    const coresPreDefinidas = [
        { nome: 'Azul RAF', cor: '#6C9BCF' },
        { nome: 'Branco', cor: '#FFFFFF' },
        { nome: 'Azul Escuro', cor: '#1a1a2e' },
        { nome: 'Azul Royal', cor: '#1a237e' },
        { nome: 'Azul Céu', cor: '#42a5f5' },
        { nome: 'Verde Esmeralda', cor: '#2e7d32' },
        { nome: 'Verde Menta', cor: '#26a69a' },
        { nome: 'Vermelho', cor: '#c62828' },
        { nome: 'Rosa', cor: '#ad1457' },
        { nome: 'Roxo', cor: '#6a1b9a' },
        { nome: 'Laranja', cor: '#e65100' },
        { nome: 'Amarelo', cor: '#f9a825' },
        { nome: 'Cinza', cor: '#37474f' },
        { nome: 'Cinza Claro', cor: '#78909c' },
        { nome: 'Preto', cor: '#000000' },
        { nome: 'Marrom', cor: '#4e342e' }
    ];

    // ==============================================
    // OBTER ID DO UTILIZADOR ATUAL
    // ==============================================
    const getCurrentUserId = () => {
        try {
            const token = localStorage.getItem('token');
            if (token) {
                const payload = JSON.parse(atob(token.split('.')[1]));
                return payload.id || payload.userId || payload.sub;
            }
        } catch (err) {
            console.error('Erro ao obter ID do utilizador:', err);
        }
        return null;
    };

    // ==============================================
    // FUNÇÃO PARA NOTIFICAR ATUALIZAÇÃO DE UTILIZADORES
    // ==============================================
    const notificarAtualizacaoUtilizadores = (empresaId, userId, action) => {
        console.log('📢 [EMPRESAS] A notificar atualização de utilizadores:', { empresaId, userId, action });

        window.dispatchEvent(new CustomEvent('utilizadoresAtualizados', {
            detail: {
                empresaId: empresaId,
                userId: userId,
                action: action || 'update',
                timestamp: Date.now(),
                source: 'Empresas.js'
            }
        }));

        if (action === 'addUser' || action === 'removeUser') {
            window.dispatchEvent(new CustomEvent('associacaoEmpresaUtilizadorAlterada', {
                detail: {
                    empresaId: empresaId,
                    userId: userId,
                    action: action,
                    timestamp: Date.now()
                }
            }));
        }

        try {
            localStorage.setItem('utilizadoresAtualizados', JSON.stringify({
                empresaId: empresaId,
                userId: userId,
                action: action || 'update',
                timestamp: Date.now(),
                source: 'Empresas.js'
            }));
        } catch (err) {
            console.warn('Erro ao guardar no localStorage:', err);
        }
    };

    // Configuração das TABS
    const modalTabs = [
        { id: 'geral', label: 'Informações Gerais', icon: 'apartment' },
        { id: 'logo', label: 'Logotipo', icon: 'image' },
        { id: 'fiscal', label: 'Configurações Fiscais', icon: 'receipt' },
        { id: 'morada', label: 'Morada', icon: 'location_on' },
        { id: 'contacto', label: 'Contactos', icon: 'phone' },
        { id: 'financeiro', label: 'Financeiro', icon: 'attach_money' },
        { id: 'bancario', label: 'Dados Bancários', icon: 'account_balance' },
        { id: 'sistema', label: 'Sistema', icon: 'settings' },
        { id: 'modulos', label: 'Módulos', icon: 'apps' },
        { id: 'plano', label: 'Plano', icon: 'card_membership' },
        { id: 'licenca', label: 'Licença', icon: 'ticket' }
    ];

    const paises = ['Moçambique', 'Portugal', 'Brasil', 'Angola', 'Cabo Verde', 'São Tomé e Príncipe', 'Guiné-Bissau', 'Timor-Leste'];
    const bancos = ['BCI', 'Millennium BIM', 'Standard Bank', 'Moza Banco', 'ABSA', 'United Bank of Africa', 'First National Bank', 'Ecobank', 'Nedbank', 'Outro'];
    const opcoesIVA = [
        { valor: 0, label: 'ISPC Trimestral (15%)' },
        { valor: 5, label: '5% Civa' },
        { valor: 16, label: '16% Normal' }
    ];
    const regimesIVA = ['Normal', 'ISPC', 'Civa'];
    const tiposPlano = ['Trial', 'Basico', 'Profissional', 'Enterprise', 'Personalizado'];
    const tiposLicenca = ['Trial', 'Basico', 'Profissional', 'Enterprise', 'Custom'];
    const statusOptions = ['Ativa', 'Suspensa', 'Cancelada', 'EmAprovacao'];
    const setoresAtividade = ['Comercio', 'Servicos', 'Industria', 'Agricultura', 'Construcao', 'Transportes', 'Turismo', 'Saude', 'Educacao', 'Tecnologia', 'Financeiro', 'Outro'];
    const idiomas = ['pt-PT', 'pt-BR', 'en-US', 'es-ES', 'fr-FR'];
    const timezones = ['Africa/Maputo', 'Africa/Luanda', 'America/Sao_Paulo', 'Europe/Lisbon'];
    const formatosData = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'];
    const formatosHora = ['24h', '12h'];

    // ==============================================
    // ESTRUTURA BASE DOS MÓDULOS
    // ==============================================
    const estruturaBaseModulos = {
        dashboard: {
            ativo: true,
            submodulos: {
                overview: true,
                estatisticas: true,
                atividades_recentes: true,
                graficos: true
            }
        },
        vendas: {
            ativo: true,
            submodulos: {
                dashboard_vendas: true,
                faturas: true,
                cotacoes: true,
                recibos: true,
                guias_entrega: true,
                recebimentos: true,
                relatorios_vendas: true,
                configuracoes_vendas: true
            }
        },
        comercial: {
            ativo: true,
            submodulos: {
                clientes: true,
                fornecedores: true
            }
        },
        stock: {
            ativo: true,
            submodulos: {
                produtos: true,
                criar_produto: true,
                servicos: true,
                entrada_stock: true,
                categorias: true,
                movimentos: true,
                inventario: true,
                armazens: true
            }
        },
        analise: {
            ativo: true,
            submodulos: {
                analitico: true,
                relatorios: true,
                financeiro: true
            }
        },
        admin: {
            ativo: false,
            submodulos: {
                utilizadores: true,
                empresas: false,
                licencas: false,
                logs: false,
                definicoes: true
            }
        }
    };

    const converterModulosAntigosParaNovos = (modulosAntigos) => {
        if (!modulosAntigos || typeof modulosAntigos !== 'object') {
            return { ...estruturaBaseModulos };
        }

        const primeiroModulo = Object.values(modulosAntigos)[0];
        if (typeof primeiroModulo === 'object' && primeiroModulo?.ativo !== undefined) {
            const resultado = { ...estruturaBaseModulos };
            Object.keys(modulosAntigos).forEach(moduloId => {
                if (resultado[moduloId]) {
                    resultado[moduloId].ativo = modulosAntigos[moduloId].ativo;
                    if (modulosAntigos[moduloId].submodulos) {
                        Object.keys(resultado[moduloId].submodulos).forEach(subId => {
                            if (modulosAntigos[moduloId].submodulos[subId] !== undefined) {
                                resultado[moduloId].submodulos[subId] = modulosAntigos[moduloId].submodulos[subId];
                            }
                        });
                    }
                }
            });
            return resultado;
        }

        const resultado = { ...estruturaBaseModulos };
        const mapeamento = {
            vendas: 'vendas',
            stock: 'stock',
            financeiro: 'analise',
            rh: 'admin',
            projectos: 'admin'
        };

        Object.keys(mapeamento).forEach(chaveAntiga => {
            if (modulosAntigos[chaveAntiga] !== undefined) {
                const chaveNova = mapeamento[chaveAntiga];
                if (resultado[chaveNova]) {
                    resultado[chaveNova].ativo = modulosAntigos[chaveAntiga] === true;
                }
            }
        });

        return resultado;
    };

    // ==============================================
    // FUNÇÃO PARA ATUALIZAR MÓDULOS EM TEMPO REAL
    // ==============================================
    const handleModuloChange = (e, setFormState, formState) => {
        const { name, checked } = e.target;
        const parts = name.split('.');

        if (parts.length === 4 && parts[0] === 'configuracoes' && parts[1] === 'modulosAtivos') {
            const moduloId = parts[2];
            const campo = parts[3];

            if (campo === 'ativo') {
                setFormState(prev => {
                    const newState = { ...prev };
                    if (!newState.configuracoes) newState.configuracoes = {};
                    if (!newState.configuracoes.modulosAtivos) newState.configuracoes.modulosAtivos = {};
                    if (!newState.configuracoes.modulosAtivos[moduloId]) {
                        newState.configuracoes.modulosAtivos[moduloId] = {
                            ativo: true,
                            submodulos: { ...estruturaBaseModulos[moduloId]?.submodulos }
                        };
                    }
                    newState.configuracoes.modulosAtivos[moduloId].ativo = checked;
                    return newState;
                });
                return;
            }
        }

        if (parts.length === 5 && parts[0] === 'configuracoes' && parts[1] === 'modulosAtivos') {
            const moduloId = parts[2];
            const submoduloId = parts[4];

            setFormState(prev => {
                const newState = { ...prev };
                if (!newState.configuracoes) newState.configuracoes = {};
                if (!newState.configuracoes.modulosAtivos) newState.configuracoes.modulosAtivos = {};
                if (!newState.configuracoes.modulosAtivos[moduloId]) {
                    newState.configuracoes.modulosAtivos[moduloId] = {
                        ativo: true,
                        submodulos: { ...estruturaBaseModulos[moduloId]?.submodulos }
                    };
                }
                if (!newState.configuracoes.modulosAtivos[moduloId].submodulos) {
                    newState.configuracoes.modulosAtivos[moduloId].submodulos = { ...estruturaBaseModulos[moduloId]?.submodulos };
                }
                newState.configuracoes.modulosAtivos[moduloId].submodulos[submoduloId] = checked;
                return newState;
            });
            return;
        }

        const { value, type } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        if (name.includes('.')) {
            const parts2 = name.split('.');
            if (parts2.length === 2) {
                setFormState(prev => ({ ...prev, [parts2[0]]: { ...prev[parts2[0]], [parts2[1]]: newValue } }));
            } else if (parts2.length === 3) {
                setFormState(prev => ({
                    ...prev,
                    [parts2[0]]: { ...prev[parts2[0]], [parts2[1]]: { ...prev[parts2[0]][parts2[1]], [parts2[2]]: newValue } }
                }));
            } else if (parts2.length === 4) {
                setFormState(prev => ({
                    ...prev,
                    [parts2[0]]: {
                        ...prev[parts2[0]],
                        [parts2[1]]: {
                            ...prev[parts2[0]]?.[parts2[1]],
                            [parts2[2]]: newValue
                        }
                    }
                }));
            }
        } else {
            setFormState(prev => ({ ...prev, [name]: newValue }));
        }
    };

    // ==============================================
// FUNÇÃO PARA RENDERIZAR MÓDULOS COM SUBMÓDULOS
// ==============================================
const renderizarModulos = (modulos, handleChange, setFormState, formState) => {
    const estruturaModulos = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: 'dashboard',
            submodulos: [
                { id: 'overview', label: 'Visão Geral' },
                { id: 'estatisticas', label: 'Estatísticas' },
                { id: 'atividades_recentes', label: 'Atividades Recentes' },
                { id: 'graficos', label: 'Gráficos' }
            ]
        },
        {
            id: 'vendas',
            label: 'Vendas e Faturação',
            icon: 'receipt',
            submodulos: [
                { id: 'dashboard_vendas', label: 'Dashboard de Vendas' },
                { id: 'faturas', label: 'Faturas' },
                { id: 'cotacoes', label: 'Cotações' },
                { id: 'recibos', label: 'Recibos' },
                { id: 'guias_entrega', label: 'Guias de Entrega' },
                { id: 'recebimentos', label: 'Recebimentos' },
                { id: 'relatorios_vendas', label: 'Relatório de Vendas' },
                { id: 'configuracoes_vendas', label: 'Configurações' }
            ]
        },
        {
            id: 'comercial',
            label: 'Gestão Comercial',
            icon: 'storefront',
            submodulos: [
                { id: 'clientes', label: 'Clientes' },
                { id: 'fornecedores', label: 'Fornecedores' }
            ]
        },
        {
            id: 'stock',
            label: 'Gestão de Stock',
            icon: 'inventory',
            submodulos: [
                { id: 'produtos', label: 'Listar Produtos' },
                { id: 'criar_produto', label: 'Criar Produto' },
                { id: 'servicos', label: 'Serviços' },
                { id: 'entrada_stock', label: 'Entrada de Stock' },
                { id: 'categorias', label: 'Categorias' },
                { id: 'movimentos', label: 'Movimentos' },
                { id: 'inventario', label: 'Inventário' },
                { id: 'armazens', label: 'Armazéns' }
            ]
        },
        {
            id: 'analise',
            label: 'Análise e Relatórios',
            icon: 'analytics',
            submodulos: [
                { id: 'analitico', label: 'Analítico' },
                { id: 'relatorios', label: 'Relatórios' },
                { id: 'financeiro', label: 'Financeiro' }
            ]
        },
        {
            id: 'admin',
            label: 'Administração',
            icon: 'admin_panel_settings',
            submodulos: [
                { id: 'utilizadores', label: 'Utilizadores' },
                { id: 'empresas', label: 'Empresas' },
                { id: 'licencas', label: 'Licenças' },
                { id: 'logs', label: 'Logs' },
                { id: 'definicoes', label: 'Definições' }
            ]
        }
    ];

    const modulosSeguro = modulos && typeof modulos === 'object' ? modulos : {};

    return estruturaModulos.map(modulo => {
        const moduloData = modulosSeguro[modulo.id];
        let moduloAtivo = true;
        let submodulosAtivos = {};

        if (moduloData === undefined || moduloData === null) {
            moduloAtivo = true;
            modulo.submodulos.forEach(sub => {
                submodulosAtivos[sub.id] = true;
            });
        } else if (typeof moduloData === 'boolean') {
            moduloAtivo = moduloData;
            modulo.submodulos.forEach(sub => {
                submodulosAtivos[sub.id] = true;
            });
        } else if (typeof moduloData === 'object' && !Array.isArray(moduloData)) {
            if ('ativo' in moduloData || 'submodulos' in moduloData) {
                moduloAtivo = moduloData.ativo === true || moduloData.ativo === 'true' || moduloData.ativo === 'on';
                submodulosAtivos = moduloData.submodulos || {};
                modulo.submodulos.forEach(sub => {
                    if (!(sub.id in submodulosAtivos)) {
                        submodulosAtivos[sub.id] = true;
                    }
                    if (submodulosAtivos[sub.id] === 'on' || submodulosAtivos[sub.id] === 'true') {
                        submodulosAtivos[sub.id] = true;
                    }
                });
            } else {
                moduloAtivo = true;
                modulo.submodulos.forEach(sub => {
                    submodulosAtivos[sub.id] = true;
                });
            }
        } else {
            moduloAtivo = true;
            modulo.submodulos.forEach(sub => {
                submodulosAtivos[sub.id] = true;
            });
        }

        const moduloFieldName = `configuracoes.modulosAtivos.${modulo.id}.ativo`;

        return (
            <div key={modulo.id} className="empresas-modulo-card">
                <div className="empresas-modulo-header">
                    <div className="empresas-modulo-toggle">
                        <input
                            type="checkbox"
                            name={moduloFieldName}
                            checked={moduloAtivo}
                            onChange={(e) => handleChange(e, setFormState, formState)}
                            id={`modulo-${modulo.id}`}
                        />
                        <label htmlFor={`modulo-${modulo.id}`} className="empresas-modulo-label">
                            <span className="empresas-modulo-icon"><Icon name={modulo.icon} size={16} /></span>
                            <span className="empresas-modulo-nome">{modulo.label}</span>
                            <span className="empresas-modulo-count">{modulo.submodulos.length} itens</span>
                        </label>
                    </div>
                </div>

                {moduloAtivo && (
                    <div className="empresas-submodulos-grid">
                        {modulo.submodulos.map(sub => {
                            const subValor = submodulosAtivos[sub.id];
                            const subAtivo = subValor === true || subValor === 'true' || subValor === 'on';
                            const subFieldName = `configuracoes.modulosAtivos.${modulo.id}.submodulos.${sub.id}`;

                            return (
                                <div key={sub.id} className="empresas-submodulo-item">
                                    <input
                                        type="checkbox"
                                        name={subFieldName}
                                        checked={subAtivo}
                                        onChange={(e) => handleChange(e, setFormState, formState)}
                                        id={`submodulo-${modulo.id}-${sub.id}`}
                                    />
                                    <label htmlFor={`submodulo-${modulo.id}-${sub.id}`}>
                                        {sub.label}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    });
};

    const [formData, setFormData] = useState({
        nome: '', nomeCurto: '', slug: '', imagemPerfil: '', website: '',
        email: '', emailAlternativo: '', telefone: '', telefoneAlternativo: '', whatsapp: '',
        alvara: '', nuit: '', cafe: '',
        morada: {
            rua: '', numero: '', complemento: '', bairro: '', quarteirao: '', casa: '',
            cidade: '', provincia: '', distrito: '', postoAdministrativo: '',
            pais: 'Moçambique', codigoPostal: '', coordenadas: { latitude: '', longitude: '' }
        },
        regimeIVA: 'Normal', percentagemIVA: 16, retencaoFonte: false,
        atividadesEconomicas: [],
        dadosBancarios: [{ banco: '', conta: '', nib: '', swift: '', titular: '', principal: true }],
        setorActividade: '', ramoAtividade: '',
        contactosEmergencia: [], sedes: [],
        configuracoes: {
            idioma: 'pt-PT', timezone: 'Africa/Maputo', formatoData: 'DD/MM/YYYY', formatoHora: '24h',
            moeda: { codigo: 'MZN', simbolo: 'MT', nome: 'Metical', casasDecimais: 2 },
            formatoNumero: { separadorDecimal: ',', separadorMilhar: '.' },
            tema: { corPrimaria: '#6C9BCF' },
            modulosAtivos: { ...estruturaBaseModulos }
        },
        plano: {
            tipo: 'Trial', dataInicio: new Date().toISOString().split('T')[0],
            limiteUtilizadores: 1, limiteProdutos: 100, limiteArmazenamento: 100
        },
        features: [], status: 'EmAprovacao', arquivado: false
    });

    const [editFormData, setEditFormData] = useState(null);

    // ==============================================
    // FUNÇÃO PARA GERAR CHAVE DE LICENÇA
    // ==============================================
    const generateLicencaKey = () => {
        const prefix = 'LIC';
        const timestamp = Date.now();
        const random = Math.random().toString(36).substring(2, 10).toUpperCase();
        return `${prefix}-${timestamp}-${random}`;
    };

    // ==============================================
    // FUNÇÃO PARA CARREGAR LIMITE DE UTILIZADORES
    // ==============================================
    const carregarLimiteUtilizadores = async (empresaId) => {
        if (!empresaId) return;

        setLoadingLimite(true);
        try {
            const response = await api.get(`/licencas/empresa/${empresaId}/limite-utilizadores`);
            console.log('📊 Limite de utilizadores:', response.data);
            setLimiteUtilizadores(response.data);
        } catch (err) {
            console.error('❌ Erro ao carregar limite:', err);
        } finally {
            setLoadingLimite(false);
        }
    };

    // ==============================================
    // FUNÇÃO PARA CARREGAR LICENÇA DA EMPRESA - CORRIGIDA
    // ==============================================
    const carregarLicenca = async (empresaId) => {
        if (!empresaId) {
            console.warn('⚠️ ID da empresa não fornecido para carregar licença');
            setLicencaData(null);
            setLicencaMessage({ text: 'ID da empresa inválido', type: 'warning' });
            setLoadingLicenca(false);
            return;
        }

        setLoadingLicenca(true);
        setLicencaMessage({ text: '', type: '' });

        try {
            console.log('🔍 A carregar licença para empresa:', empresaId);

            const response = await api.get(`/licencas/empresa/${empresaId}`);

            console.log('📡 Resposta da API de licença:', JSON.stringify(response.data, null, 2));

            let licenca = null;

            if (response.data && response.data.licenca) {
                licenca = response.data.licenca;
                console.log('✅ Licença encontrada na estrutura "licenca"');
            } else if (response.data && response.data.data) {
                licenca = response.data.data;
                console.log('✅ Licença encontrada na estrutura "data"');
            } else if (response.data && response.data._id) {
                licenca = response.data;
                console.log('✅ Licença encontrada diretamente');
            } else if (response.data && response.data.success && response.data.licenca) {
                licenca = response.data.licenca;
                console.log('✅ Licença encontrada na estrutura "success.licenca"');
            }

            if (licenca) {
                const licencaId = licenca.id || licenca._id;

                if (licenca.chave === 'SEM-LICENCA' || licenca.chave === 'ERROR-LICENCA') {
                    console.warn('⚠️ Licença inválida ou de erro:', licenca.chave);
                    setLicencaData(null);
                    setEditLicencaData({
                        chave: generateLicencaKey(),
                        tipoPrazo: 'Mensal',
                        dataFim: '',
                        plano: 'Basico',
                        limiteUtilizadores: 5,
                        limiteProdutos: 100,
                        ativa: true
                    });
                    setLicencaMessage({ text: 'Empresa sem licença ativa', type: 'warning' });
                    setLimiteUtilizadores({ limite: 0, utilizadoresAtuais: 0, disponivel: 0 });
                    setLoadingLicenca(false);
                    return;
                }

                setLicencaData({
                    ...licenca,
                    _id: licencaId,
                    id: licencaId,
                    dataExpiracao: licenca.dataExpiracao || licenca.dataFim || null
                });

                setEditLicencaData({
                    chave: licenca.chave || generateLicencaKey(),
                    tipoPrazo: licenca.tipoPrazo || 'Mensal',
                    dataFim: licenca.dataFim ? new Date(licenca.dataFim).toISOString().split('T')[0] : '',
                    dataExpiracao: licenca.dataExpiracao ? new Date(licenca.dataExpiracao).toISOString().split('T')[0] : '',
                    plano: licenca.plano || 'Basico',
                    limiteUtilizadores: licenca.limiteUtilizadores || 5,
                    limiteProdutos: licenca.limiteProdutos || 100,
                    ativa: licenca.ativa !== undefined ? licenca.ativa : true
                });

                setLicencaMessage({ text: 'Licença carregada com sucesso!', type: 'success' });
                await carregarLimiteUtilizadores(empresaId);
            } else {
                console.warn('⚠️ Nenhuma licença encontrada para a empresa:', empresaId);
                setLicencaData(null);
                setEditLicencaData({
                    chave: generateLicencaKey(),
                    tipoPrazo: 'Mensal',
                    dataFim: '',
                    dataExpiracao: '',
                    plano: 'Basico',
                    limiteUtilizadores: 5,
                    limiteProdutos: 100,
                    ativa: true
                });
                setLicencaMessage({ text: 'Empresa sem licença', type: 'warning' });
                setLimiteUtilizadores({ limite: 0, utilizadoresAtuais: 0, disponivel: 0 });
            }
        } catch (err) {
            console.error('❌ Erro ao carregar licença:', err);
            console.error('❌ Detalhes:', err.response?.data);

            if (err.response && err.response.status === 404) {
                setLicencaData(null);
                setEditLicencaData({
                    chave: generateLicencaKey(),
                    tipoPrazo: 'Mensal',
                    dataFim: '',
                    dataExpiracao: '',
                    plano: 'Basico',
                    limiteUtilizadores: 5,
                    limiteProdutos: 100,
                    ativa: true
                });
                setLicencaMessage({ text: 'Empresa sem licença', type: 'warning' });
                setLimiteUtilizadores({ limite: 0, utilizadoresAtuais: 0, disponivel: 0 });
            } else {
                setLicencaMessage({
                    text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao carregar licença',
                    type: 'danger'
                });
                setLicencaData(null);
            }
        } finally {
            setLoadingLicenca(false);
        }
    };


    // ==============================================
    // FUNÇÃO PARA SALVAR LICENÇA
    // ==============================================
    const salvarLicenca = async () => {
        if (!editFormData) {
            setLicencaMessage({ text: 'Dados da empresa não carregados', type: 'danger' });
            return;
        }

        setLoadingLicenca(true);
        setLicencaMessage({ text: '', type: '' });

        try {
            const empresaId = editFormData._id || selectedEmpresa?._id;

            if (!empresaId) {
                setLicencaMessage({ text: 'ID da empresa não encontrado', type: 'danger' });
                setLoadingLicenca(false);
                return;
            }

            const licencaPayload = {
                empresaId: empresaId,
                chave: editLicencaData.chave || generateLicencaKey(),
                tipoPrazo: editLicencaData.tipoPrazo || 'Mensal',
                dataFim: editLicencaData.tipoPrazo === 'DataFim' && editLicencaData.dataFim
                    ? new Date(editLicencaData.dataFim).toISOString()
                    : null,
                plano: editLicencaData.plano || 'Basico',
                limiteUtilizadores: parseInt(editLicencaData.limiteUtilizadores) || 5,
                limiteProdutos: parseInt(editLicencaData.limiteProdutos) || 100,
                ativa: editLicencaData.ativa !== undefined ? editLicencaData.ativa : true
            };

            console.log('📦 Payload da licença:', licencaPayload);
            console.log('🏢 Empresa ID:', empresaId);

            let response;
            const licencaId = licencaData?.id || licencaData?._id;

            if (licencaId) {
                console.log('🔄 Atualizando licença existente:', licencaId);
                response = await api.put(`/licencas/${licencaId}`, licencaPayload);
            } else {
                console.log('➕ Criando nova licença para empresa:', empresaId);
                response = await api.post('/licencas', licencaPayload);
            }

            console.log('📡 Resposta:', response.data);

            if (response.data && (response.data._id || response.data.id || response.data.licenca || response.data.success)) {
                setLicencaMessage({ text: 'Licença salva com sucesso!', type: 'success' });
                await carregarLicenca(empresaId);
                setIsEditingLicenca(false);
                carregarEmpresasComForca();
                setTimeout(() => setLicencaMessage({ text: '', type: '' }), 3000);
            } else {
                setLicencaMessage({
                    text: response.data?.erro || 'Erro ao salvar licença',
                    type: 'danger'
                });
            }
        } catch (err) {
            console.error('❌ Erro ao salvar licença:', err);
            setLicencaMessage({
                text: err.response?.data?.erro || err.response?.data?.mensagem || 'Erro ao salvar licença',
                type: 'danger'
            });
        } finally {
            setLoadingLicenca(false);
        }
    };

    // ==============================================
    // FUNÇÃO PARA ALTERAR STATUS DA LICENÇA
    // ==============================================
    const toggleLicencaStatus = async () => {
        const licencaId = licencaData?.id || licencaData?._id;

        if (!licencaId) {
            setLicencaMessage({ text: 'Nenhuma licença para alterar', type: 'warning' });
            return;
        }

        setLoadingLicenca(true);
        try {
            const novaAtiva = !licencaData.ativa;
            console.log(`🔄 Alterando status da licença ${licencaId} para: ${novaAtiva}`);

            const response = await api.put(`/licencas/${licencaId}`, {
                ativa: novaAtiva,
                empresaId: editFormData?._id || selectedEmpresa?._id
            });

            console.log('📡 Resposta:', response.data);

            if (response.data && (response.data._id || response.data.id || response.data.licenca || response.data.success)) {
                setLicencaMessage({
                    text: `Licença ${novaAtiva ? 'ativada' : 'desativada'} com sucesso!`,
                    type: 'success'
                });
                await carregarLicenca(editFormData?._id || selectedEmpresa?._id);
                setTimeout(() => setLicencaMessage({ text: '', type: '' }), 3000);
            } else {
                setLicencaMessage({
                    text: response.data?.erro || 'Erro ao alterar status',
                    type: 'danger'
                });
            }
        } catch (err) {
            console.error('❌ Erro ao alterar status da licença:', err);
            setLicencaMessage({
                text: err.response?.data?.erro || 'Erro ao alterar status da licença',
                type: 'danger'
            });
        } finally {
            setLoadingLicenca(false);
        }
    };

    // ==============================================
    // FUNÇÃO PARA GERAR NOVA CHAVE
    // ==============================================
    const gerarNovaChave = () => {
        setEditLicencaData(prev => ({
            ...prev,
            chave: generateLicencaKey()
        }));
        setLicencaMessage({ text: 'Nova chave gerada!', type: 'success' });
        setTimeout(() => setLicencaMessage({ text: '', type: '' }), 2000);
    };

    // ==============================================
    // useEffect
    // ==============================================
    useEffect(() => {
        carregarEmpresasComForca();
        const userId = getCurrentUserId();
        console.log('👤 ID do utilizador atual (para registo):', userId);
    }, [pagination.page, filtroStatus, filtroPlano]);

    useEffect(() => {
        filtrarEmpresas();
    }, [searchTerm, empresas]);

    // ==============================================
    // RECARREGAR UTILIZADORES QUANDO O MODAL FOR ABERTO
    // ==============================================
    useEffect(() => {
        if (showUsersModal && selectedEmpresa) {
            console.log('📊 [EMPRESAS] Modal de utilizadores aberto, recarregando dados...');
            carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
            carregarUtilizadoresDisponiveis(selectedEmpresa._id);
            carregarLimiteUtilizadores(selectedEmpresa._id);
        }
    }, [showUsersModal, selectedEmpresa]);

    // ==============================================
    // ESCUTAR EVENTOS DE ATUALIZAÇÃO DE UTILIZADORES
    // ==============================================
    useEffect(() => {
        const handleUtilizadoresAtualizados = (event) => {
            console.log('🔄 [EMPRESAS] Evento utilizadoresAtualizados recebido:', event.detail);

            const { empresaId, action } = event.detail || {};

            if (selectedEmpresa?._id) {
                if (!empresaId || empresaId === selectedEmpresa._id) {
                    console.log(`📊 [EMPRESAS] Atualizando dados da empresa selecionada ${selectedEmpresa._id} após ${action || 'atualização'}`);
                    carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                    carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                    carregarLimiteUtilizadores(selectedEmpresa._id);
                }
            }

            carregarEmpresasComForca();
        };

        const handleAssociacaoAlterada = (event) => {
            console.log('🔄 [EMPRESAS] Evento associacaoEmpresaUtilizadorAlterada recebido:', event.detail);

            const { empresaId, action } = event.detail || {};

            if (selectedEmpresa?._id) {
                if (!empresaId || empresaId === selectedEmpresa._id) {
                    console.log(`📊 [EMPRESAS] Atualizando dados da empresa selecionada ${selectedEmpresa._id} após associação ${action}`);
                    carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                    carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                    carregarLimiteUtilizadores(selectedEmpresa._id);
                }
            }

            carregarEmpresasComForca();
        };

        const handleStorageChange = (e) => {
            if (e.key === 'utilizadoresAtualizados') {
                try {
                    const data = JSON.parse(e.newValue);
                    console.log('📥 [EMPRESAS] Evento do localStorage recebido:', data);

                    if (selectedEmpresa?._id) {
                        if (!data.empresaId || data.empresaId === selectedEmpresa._id) {
                            carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                            carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                            carregarLimiteUtilizadores(selectedEmpresa._id);
                        }
                    }
                    carregarEmpresasComForca();
                } catch (err) {
                    console.error('Erro ao processar evento do storage:', err);
                }
            }
        };

        window.addEventListener('utilizadoresAtualizados', handleUtilizadoresAtualizados);
        window.addEventListener('associacaoEmpresaUtilizadorAlterada', handleAssociacaoAlterada);
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('utilizadoresAtualizados', handleUtilizadoresAtualizados);
            window.removeEventListener('associacaoEmpresaUtilizadorAlterada', handleAssociacaoAlterada);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [selectedEmpresa]);

    const api = axios.create({
        baseURL: '/api',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });

    // ==============================================
    // FUNÇÕES DE CRUD DE EMPRESAS - CORRIGIDA
    // ==============================================
    const carregarEmpresas = async () => {
        setLoading(true);
        try {
            const params = {
                page: pagination.page,
                limit: pagination.limit,
                status: filtroStatus !== 'todos' ? filtroStatus : undefined,
                plano: filtroPlano !== 'todos' ? filtroPlano : undefined,
                search: searchTerm || undefined
            };
            const response = await api.get('/empresas', { params });
            if (response.data.success) {
                console.log('✅ Empresas carregadas:', response.data.data.length);

                const empresasComLicenca = [];

                for (const empresa of response.data.data) {
                    try {
                        const licencaResponse = await api.get(`/licencas/empresa/${empresa._id}`);

                        let licenca = null;
                        if (licencaResponse.data && licencaResponse.data.licenca) {
                            licenca = licencaResponse.data.licenca;
                        } else if (licencaResponse.data && licencaResponse.data.data) {
                            licenca = licencaResponse.data.data;
                        } else if (licencaResponse.data && licencaResponse.data._id) {
                            licenca = licencaResponse.data;
                        }

                        empresasComLicenca.push({
                            ...empresa,
                            licenca: licenca
                        });
                    } catch (err) {
                        empresasComLicenca.push(empresa);
                    }
                }

                setEmpresas(empresasComLicenca);
                setFilteredEmpresas(empresasComLicenca);
                setPagination({
                    ...pagination,
                    total: response.data.pagination?.total || response.data.data.length,
                    pages: response.data.pagination?.pages || 1
                });
                setIsSuperadmin(response.data.isSuperadmin || false);
            }
        } catch (err) {
            setMessage({ text: err.response?.data?.erro || 'Erro ao carregar empresas', type: 'danger' });
        } finally {
            setLoading(false);
        }
    };


    // ==============================================
    // FUNÇÃO PARA CARREGAR EMPRESAS COM FORÇA (ANTI-CACHE) - CORRIGIDA
    // ==============================================
    const carregarEmpresasComForca = async () => {
        setLoading(true);
        try {
            const params = {
                page: pagination.page,
                limit: pagination.limit,
                status: filtroStatus !== 'todos' ? filtroStatus : undefined,
                plano: filtroPlano !== 'todos' ? filtroPlano : undefined,
                search: searchTerm || undefined,
                _t: Date.now()
            };

            const response = await api.get('/empresas', {
                params,
                headers: {
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0'
                }
            });

            if (response.data.success) {
                console.log('✅ Empresas recarregadas com força:', response.data.data.length);

                const empresasComLicenca = [];

                for (const empresa of response.data.data) {
                    try {
                        const licencaResponse = await api.get(`/licencas/empresa/${empresa._id}`);

                        let licenca = null;
                        if (licencaResponse.data && licencaResponse.data.licenca) {
                            licenca = licencaResponse.data.licenca;
                        } else if (licencaResponse.data && licencaResponse.data.data) {
                            licenca = licencaResponse.data.data;
                        } else if (licencaResponse.data && licencaResponse.data._id) {
                            licenca = licencaResponse.data;
                        }

                        empresasComLicenca.push({
                            ...empresa,
                            licenca: licenca
                        });
                    } catch (err) {
                        console.log(`⚠️ Empresa ${empresa.nome} sem licença`);
                        empresasComLicenca.push(empresa);
                    }
                }

                console.log('✅ Empresas com licença carregadas:', empresasComLicenca.length);

                setEmpresas(empresasComLicenca);
                setFilteredEmpresas(empresasComLicenca);
                setPagination({
                    ...pagination,
                    total: response.data.pagination?.total || response.data.data.length,
                    pages: response.data.pagination?.pages || 1
                });
                setIsSuperadmin(response.data.isSuperadmin || false);
            }
        } catch (err) {
            console.error('❌ Erro ao carregar empresas:', err);
            setMessage({ text: err.response?.data?.erro || 'Erro ao carregar empresas', type: 'danger' });
        } finally {
            setLoading(false);
        }
    };


    // ==============================================
    // FILTRAR EMPRESAS
    // ==============================================
    const filtrarEmpresas = () => {
        console.log('🔍 Filtrando empresas...');
        console.log('📊 Total de empresas:', empresas.length);
        console.log('🔍 Termo de pesquisa:', `"${searchTerm}"`);

        if (!empresas || empresas.length === 0) {
            setFilteredEmpresas([]);
            return;
        }

        if (!searchTerm || searchTerm.trim() === '') {
            console.log('✅ Sem filtro, mostrando todas as empresas');
            setFilteredEmpresas(empresas);
            return;
        }

        const term = searchTerm.toLowerCase().trim();
        console.log('🔍 Termo limpo:', term);

        const resultados = empresas.filter(emp => {
            const match =
                (emp.nome || '').toLowerCase().includes(term) ||
                (emp.nomeCurto || '').toLowerCase().includes(term) ||
                (emp.email || '').toLowerCase().includes(term) ||
                (emp.nuit || '').toLowerCase().includes(term) ||
                (emp.cafe || '').toLowerCase().includes(term) ||
                (emp.telefone || '').includes(term) ||
                (emp.website || '').toLowerCase().includes(term) ||
                (emp.alvara || '').toLowerCase().includes(term);

            if (match) {
                console.log('✅ Match encontrado:', emp.nome);
            }
            return match;
        });

        console.log('📊 Resultados do filtro:', resultados.length);
        setFilteredEmpresas(resultados);
    };

    const getImagemUrl = (imagemPerfil) => {
        if (!imagemPerfil) return null;
        if (imagemPerfil.startsWith('http://') || imagemPerfil.startsWith('https://')) {
            return imagemPerfil;
        }
        const cleanPath = imagemPerfil.replace(/^\/+/, '');
        let finalPath = cleanPath;
        if (finalPath.startsWith('uploads/uploads/')) {
            finalPath = finalPath.replace('uploads/uploads/', 'uploads/');
        }
        return `http://localhost:3000/${finalPath}`;
    };

    // ==============================================
    // FUNÇÕES DE GESTÃO DE UTILIZADORES
    // ==============================================
    const openUsersModal = async (empresa) => {
        console.log('📊 [EMPRESAS] Abrindo modal de utilizadores para:', empresa.nome);

        setSelectedEmpresa(empresa);
        setUsersModalMessage({ text: '', type: '' });

        setEmpresaUsers([]);
        setAvailableUsers([]);

        setShowUsersModal(true);

        await carregarUtilizadoresDaEmpresa(empresa._id);
        await carregarUtilizadoresDisponiveis(empresa._id);
        await carregarLimiteUtilizadores(empresa._id);
    };

    const carregarUtilizadoresDaEmpresa = async (empresaId) => {
        setLoadingUsers(true);
        try {
            const response = await api.get(`/empresas/${empresaId}/utilizadores`);
            if (response.data.success) {
                const users = response.data.data.map(user => ({
                    ...user,
                    perfil: user.perfil || user.role || 'Cliente',
                    isActive: user.isActive !== undefined ? (user.isActive === true || user.isActive === 'true' || user.isActive === 1) : true,
                    isAdmin: user.isAdmin === true || user.isAdmin === 'true' || user.isAdmin === 1
                }));
                setEmpresaUsers(users);
                console.log('👥 Utilizadores da empresa carregados:', users.length);
            }
        } catch (err) {
            console.error('Erro ao carregar utilizadores da empresa:', err);
            setUsersModalMessage({ text: 'Erro ao carregar utilizadores da empresa', type: 'danger' });
        } finally {
            setLoadingUsers(false);
        }
    };

    const carregarUtilizadoresDisponiveis = async (empresaId) => {
        try {
            const response = await api.get(`/empresas/${empresaId}/utilizadores/disponiveis`);
            if (response.data.success) {
                setAvailableUsers(response.data.data);
                console.log('👥 Utilizadores disponíveis carregados:', response.data.data.length);
            }
        } catch (err) {
            console.error('Erro ao carregar utilizadores disponíveis:', err);
        }
    };

    // ==============================================
    // ADICIONAR UTILIZADOR
    // ==============================================
    const adicionarUtilizadorEmpresa = async () => {
        if (!selectedUserToAdd) {
            setUsersModalMessage({ text: 'Selecione um utilizador para adicionar', type: 'warning' });
            return;
        }

        if (limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0) {
            setUsersModalMessage({
                text: `⚠️ Limite de utilizadores atingido (${limiteUtilizadores.utilizadoresAtuais}/${limiteUtilizadores.limite}). Contacte o administrador para aumentar o limite da licença.`,
                type: 'danger'
            });
            return;
        }

        setLoadingUsers(true);
        setUsersModalMessage({ text: '', type: '' });

        try {
            const response = await api.post(`/empresas/${selectedEmpresa._id}/utilizadores`, {
                userId: selectedUserToAdd
            });

            if (response.data.success) {
                if (selectedEmpresa.status === 'Ativa' && !selectedEmpresa.arquivado) {
                    try {
                        await api.put(`/utilizadores/${selectedUserToAdd}`, {
                            ativo: true
                        });
                    } catch (userErr) {
                        console.error('Erro ao reativar utilizador:', userErr);
                    }
                }

                setUsersModalMessage({ text: 'Utilizador adicionado com sucesso!', type: 'success' });

                await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                await carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                await carregarLimiteUtilizadores(selectedEmpresa._id);
                setSelectedUserToAdd('');
                await carregarEmpresasComForca();

                notificarAtualizacaoUtilizadores(selectedEmpresa._id, selectedUserToAdd, 'addUser');

                setTimeout(() => setUsersModalMessage({ text: '', type: '' }), 3000);
            }
        } catch (err) {
            console.error('Erro ao adicionar utilizador:', err);
            setUsersModalMessage({
                text: err.response?.data?.erro || 'Erro ao adicionar utilizador',
                type: 'danger'
            });
        } finally {
            setLoadingUsers(false);
        }
    };

    // ==============================================
    // FUNÇÃO PARA ABRIR MODAL DE REMOÇÃO
    // ==============================================
    const openConfirmRemoveUserModal = (user) => {
        console.log('🔍 [REMOVER] Utilizador a remover:', user);
        console.log('🔍 [REMOVER] Perfil do utilizador:', user.perfil);
        console.log('🔍 [REMOVER] isSuperadmin:', user.isSuperadmin);

        const isSuperAdmin = isUserSuperAdmin(user);

        console.log('🔍 [REMOVER] É Superadmin?', isSuperAdmin);

        if (isSuperAdmin) {
            const superAdmins = empresaUsers.filter(u => isUserSuperAdmin(u));
            console.log('🔍 [REMOVER] Total de Superadmins na empresa:', superAdmins.length);

            if (superAdmins.length <= 1) {
                console.log('🚨 [REMOVER] Último Superadmin! A mostrar alerta crítico.');
                setIsLastSuperAdmin(true);
                setSuperAdminToRemove(user);
                setShowSuperAdminWarningModal(true);
                return;
            }
        }

        console.log('✅ [REMOVER] Abrindo modal de remoção normal para:', user.nome);
        setUserToRemove(user);
        setShowConfirmRemoveUserModal(true);
    };

    const closeConfirmRemoveUserModal = () => {
        setShowConfirmRemoveUserModal(false);
        setUserToRemove(null);
    };

    // ==============================================
    // CONFIRMAR REMOÇÃO DE UTILIZADOR
    // ==============================================
    const confirmRemoveUser = async () => {
        if (!userToRemove) {
            console.warn('⚠️ [REMOVER] Nenhum utilizador selecionado para remover');
            return;
        }

        console.log('🗑️ [REMOVER] Confirmando remoção de:', userToRemove.nome);

        const isSuperAdmin = isUserSuperAdmin(userToRemove);

        if (isSuperAdmin) {
            const superAdmins = empresaUsers.filter(u => isUserSuperAdmin(u));
            if (superAdmins.length <= 1) {
                setUsersModalMessage({
                    text: '⚠️ Não é possível remover o único Superadmin da empresa!',
                    type: 'danger'
                });
                closeConfirmRemoveUserModal();
                return;
            }
        }

        setRemovingUser(true);
        try {
            const userIdToRemove = userToRemove.userId || userToRemove._id;
            console.log(`📡 [REMOVER] A remover utilizador ${userIdToRemove} da empresa ${selectedEmpresa._id}`);

            const response = await api.delete(`/empresas/${selectedEmpresa._id}/utilizadores/${userIdToRemove}`);

            if (response.data.success) {
                console.log('✅ [REMOVER] Utilizador removido com sucesso!');
                setUsersModalMessage({
                    text: `✅ Utilizador ${userToRemove.nome} removido com sucesso!`,
                    type: 'success'
                });

                await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                await carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                await carregarLimiteUtilizadores(selectedEmpresa._id);
                await carregarEmpresasComForca();

                notificarAtualizacaoUtilizadores(selectedEmpresa._id, userIdToRemove, 'removeUser');

                closeConfirmRemoveUserModal();
                setTimeout(() => setUsersModalMessage({ text: '', type: '' }), 3000);
            } else {
                console.error('❌ [REMOVER] Erro na resposta da API:', response.data);
                setUsersModalMessage({
                    text: response.data?.erro || 'Erro ao remover utilizador',
                    type: 'danger'
                });
                closeConfirmRemoveUserModal();
            }
        } catch (err) {
            console.error('❌ [REMOVER] Erro ao remover utilizador:', err);
            console.error('❌ [REMOVER] Detalhes do erro:', err.response?.data);
            setUsersModalMessage({
                text: err.response?.data?.erro || 'Erro ao remover utilizador',
                type: 'danger'
            });
            closeConfirmRemoveUserModal();
        } finally {
            setRemovingUser(false);
        }
    };

    // ==============================================
    // ATUALIZAR ADMIN DA EMPRESA
    // ==============================================
    const atualizarAdminEmpresa = async (userId, isAdmin) => {
        setLoadingUsers(true);
        setUsersModalMessage({ text: '', type: '' });

        try {
            console.log('🔄 [TOGGLE] A atualizar permissão para:', userId);
            console.log('📊 [TOGGLE] Novo estado Admin:', isAdmin);

            const token = localStorage.getItem('token');
            const baseUrl = '/api';

            const userResponse = await axios.get(`${baseUrl}/auth/users/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            console.log('📡 [TOGGLE] Resposta do GET /auth/users:', userResponse.data);

            let userData;
            if (userResponse.data.success) {
                userData = userResponse.data.data || userResponse.data;
            } else {
                userData = userResponse.data;
            }

            if (!userData || !userData._id) {
                console.error('❌ [TOGGLE] Utilizador não encontrado:', userData);
                setUsersModalMessage({
                    text: '⚠️ Utilizador não encontrado no sistema',
                    type: 'danger'
                });
                setLoadingUsers(false);
                await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                setTimeout(() => setUsersModalMessage({ text: '', type: '' }), 3000);
                return;
            }

            const perfilAtual = userData.perfil || userData.role || 'Cliente';
            console.log('📊 [TOGGLE] Perfil atual:', perfilAtual);

            if (isUserSuperAdmin(userData)) {
                console.log('⚠️ [TOGGLE] Utilizador é Superadmin, não pode ser alterado');
                setUsersModalMessage({
                    text: '⚠️ Utilizadores Superadmin não podem ter a permissão de Admin alterada.',
                    type: 'warning'
                });
                setLoadingUsers(false);
                await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                setTimeout(() => setUsersModalMessage({ text: '', type: '' }), 3000);
                return;
            }

            const perfilOriginal = userData.perfilOriginal || perfilAtual;
            let novoPerfil;
            let perfilOriginalParaSalvar;

            if (isAdmin) {
                novoPerfil = 'Admin';
                perfilOriginalParaSalvar = perfilAtual !== 'Admin' ? perfilAtual : perfilOriginal;
            } else {
                novoPerfil = perfilOriginal || 'Cliente';
                perfilOriginalParaSalvar = null;
            }

            console.log(`🔄 [TOGGLE] Alterando perfil: ${perfilAtual} -> ${novoPerfil}`);

            const updateResponse = await axios.put(`${baseUrl}/auth/users/${userId}`, {
                perfil: novoPerfil,
                perfilOriginal: perfilOriginalParaSalvar
            }, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            console.log('📡 [TOGGLE] Resposta do PUT /auth/users:', updateResponse.data);

            if (updateResponse.data && updateResponse.data.success !== false) {
                console.log(`📡 [TOGGLE] A chamar: ${baseUrl}/api/empresas/${selectedEmpresa._id}/utilizadores/${userId}/admin`);

                const empresaResponse = await axios.put(`${baseUrl}/api/empresas/${selectedEmpresa._id}/utilizadores/${userId}/admin`, {
                    isAdmin: isAdmin
                }, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                console.log('📡 [TOGGLE] Resposta do PUT /api/empresas/utilizadores/admin:', empresaResponse.data);

                if (empresaResponse.data.success) {
                    setUsersModalMessage({
                        text: isAdmin ? '✅ Utilizador promovido a Admin com sucesso!' : '✅ Permissão de Admin removida com sucesso!',
                        type: 'success'
                    });

                    await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                    await carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                    await carregarLimiteUtilizadores(selectedEmpresa._id);
                    await carregarEmpresasComForca();

                    notificarAtualizacaoUtilizadores(selectedEmpresa._id, userId, isAdmin ? 'makeAdmin' : 'removeAdmin');

                    setTimeout(() => setUsersModalMessage({ text: '', type: '' }), 3000);
                } else {
                    console.error('❌ [TOGGLE] Erro ao atualizar na empresa:', empresaResponse.data);
                    setUsersModalMessage({
                        text: empresaResponse.data?.erro || '❌ Erro ao atualizar permissão na empresa',
                        type: 'danger'
                    });
                }
            } else {
                console.error('❌ [TOGGLE] Erro ao atualizar perfil:', updateResponse.data);
                setUsersModalMessage({
                    text: updateResponse.data?.erro || '❌ Erro ao atualizar perfil do utilizador',
                    type: 'danger'
                });
            }
        } catch (err) {
            console.error('❌ [TOGGLE] Erro detalhado:', err);
            console.error('❌ [TOGGLE] Resposta do erro:', err.response?.data);

            if (err.response?.status === 404) {
                setUsersModalMessage({
                    text: `⚠️ Utilizador não encontrado (ID: ${userId}). Pode ter sido removido do sistema.`,
                    type: 'warning'
                });

                try {
                    const token = localStorage.getItem('token');
                    const baseUrl = '/api';

                    await axios.delete(`${baseUrl}/empresas/${selectedEmpresa._id}/utilizadores/${userId}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });

                    console.log('✅ [TOGGLE] Utilizador removido da empresa automaticamente');
                    await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
                    await carregarUtilizadoresDisponiveis(selectedEmpresa._id);
                    await carregarLimiteUtilizadores(selectedEmpresa._id);
                } catch (removeErr) {
                    console.error('❌ [TOGGLE] Erro ao remover utilizador:', removeErr);
                }
            } else if (err.response?.status === 403) {
                setUsersModalMessage({
                    text: '⛔ Sem permissão para esta ação. Apenas SuperAdmin pode alterar permissões.',
                    type: 'danger'
                });
            } else if (err.response?.status === 401) {
                setUsersModalMessage({
                    text: '⛔ Sessão expirada. Faça login novamente.',
                    type: 'danger'
                });
            } else {
                setUsersModalMessage({
                    text: err.response?.data?.erro || err.response?.data?.mensagem || '❌ Erro ao atualizar permissão',
                    type: 'danger'
                });
            }

            await carregarUtilizadoresDaEmpresa(selectedEmpresa._id);
        } finally {
            setLoadingUsers(false);
        }
    };

    // ==============================================
    // FUNÇÕES DE UPLOAD
    // ==============================================
    const handleImageSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            setCreateMessage({ text: 'Formato de imagem inválido. Use JPEG, PNG, SVG ou WEBP.', type: 'danger' });
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            setCreateMessage({ text: 'A imagem deve ter no máximo 5MB.', type: 'danger' });
            return;
        }

        setUploadingImage(true);
        const uploadFormData = new FormData();
        uploadFormData.append('imagem', file);

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post('/api/empresas/upload/temp', uploadFormData, {
                headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setFormData(prev => ({ ...prev, imagemPerfil: response.data.caminho }));
                const reader = new FileReader();
                reader.onloadend = () => {
                    setTempImagePreview(reader.result);
                };
                reader.readAsDataURL(file);
                setCreateMessage({ text: 'Imagem enviada com sucesso!', type: 'success' });
                setTimeout(() => setCreateMessage({ text: '', type: '' }), 3000);
            } else {
                setCreateMessage({ text: 'Erro ao fazer upload da imagem.', type: 'danger' });
            }
        } catch (err) {
            console.error('Erro no upload:', err);
            setCreateMessage({ text: err.response?.data?.erro || 'Erro ao fazer upload.', type: 'danger' });
        } finally {
            setUploadingImage(false);
        }
    };

    const handleEditImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file || !selectedEmpresa) return;

        const validTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml', 'image/webp'];
        if (!validTypes.includes(file.type)) {
            setEditMessage({ text: 'Formato de imagem inválido. Use JPEG, PNG, SVG ou WEBP.', type: 'danger' });
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            setEditMessage({ text: 'A imagem deve ter no máximo 5MB.', type: 'danger' });
            return;
        }

        setUploadingImage(true);
        const uploadFormData = new FormData();
        uploadFormData.append('imagem', file);

        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(`/api/empresas/${selectedEmpresa._id}/imagem`, uploadFormData, {
                headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setEditFormData(prev => ({ ...prev, imagemPerfil: response.data.caminho }));
                setEditMessage({ text: 'Imagem enviada com sucesso!', type: 'success' });
                setTimeout(() => setEditMessage({ text: '', type: '' }), 3000);
                setSelectedEmpresa(prev => ({ ...prev, imagemPerfil: response.data.caminho }));
                carregarEmpresasComForca();
            } else {
                setEditMessage({ text: 'Erro ao fazer upload da imagem.', type: 'danger' });
            }
        } catch (err) {
            console.error('Erro no upload:', err);
            setEditMessage({ text: err.response?.data?.erro || 'Erro ao fazer upload.', type: 'danger' });
        } finally {
            setUploadingImage(false);
        }
    };

    const removeImage = () => {
        setFormData(prev => ({ ...prev, imagemPerfil: '' }));
        setTempImagePreview(null);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    const removeEditImage = async () => {
        if (!selectedEmpresa) return;

        setUploadingImage(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.delete(`/api/empresas/${selectedEmpresa._id}/imagem`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                setEditFormData(prev => ({ ...prev, imagemPerfil: '' }));
                setEditMessage({ text: 'Imagem removida com sucesso!', type: 'success' });
                setTimeout(() => setEditMessage({ text: '', type: '' }), 3000);
                setSelectedEmpresa(prev => ({ ...prev, imagemPerfil: '' }));
                carregarEmpresasComForca();
            }
        } catch (err) {
            console.error('Erro ao remover imagem:', err);
            setEditMessage({ text: err.response?.data?.erro || 'Erro ao remover imagem.', type: 'danger' });
        } finally {
            setUploadingImage(false);
        }
    };

    // ==============================================
    // FUNÇÕES DE DADOS BANCÁRIOS
    // ==============================================
    const addDadosBancarios = () => {
        setFormData(prev => ({
            ...prev,
            dadosBancarios: [
                ...prev.dadosBancarios,
                { banco: '', conta: '', nib: '', swift: '', titular: '', principal: false }
            ]
        }));
    };

    const removeDadosBancarios = (index) => {
        setFormData(prev => ({
            ...prev,
            dadosBancarios: prev.dadosBancarios.filter((_, i) => i !== index)
        }));
    };

    const updateDadosBancarios = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            dadosBancarios: prev.dadosBancarios.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    const addEditDadosBancarios = () => {
        setEditFormData(prev => ({
            ...prev,
            dadosBancarios: [
                ...(prev.dadosBancarios || []),
                { banco: '', conta: '', nib: '', swift: '', titular: '', principal: false }
            ]
        }));
    };

    const removeEditDadosBancarios = (index) => {
        setEditFormData(prev => ({
            ...prev,
            dadosBancarios: prev.dadosBancarios.filter((_, i) => i !== index)
        }));
    };

    const updateEditDadosBancarios = (index, field, value) => {
        setEditFormData(prev => ({
            ...prev,
            dadosBancarios: prev.dadosBancarios.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    // ==============================================
    // FUNÇÕES DE CRIAÇÃO
    // ==============================================
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        if (name.includes('.')) {
            const parts = name.split('.');
            if (parts.length === 2) {
                setFormData(prev => ({ ...prev, [parts[0]]: { ...prev[parts[0]], [parts[1]]: newValue } }));
            } else if (parts.length === 3) {
                setFormData(prev => ({
                    ...prev,
                    [parts[0]]: { ...prev[parts[0]], [parts[1]]: { ...prev[parts[0]][parts[1]], [parts[2]]: newValue } }
                }));
            } else if (parts.length === 4) {
                setFormData(prev => ({
                    ...prev,
                    [parts[0]]: {
                        ...prev[parts[0]],
                        [parts[1]]: {
                            ...prev[parts[0]]?.[parts[1]],
                            [parts[2]]: newValue
                        }
                    }
                }));
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: newValue }));
        }
    };

    const handleIVAChange = (e) => {
        const valor = parseInt(e.target.value);
        setFormData(prev => ({
            ...prev,
            percentagemIVA: isNaN(valor) ? 0 : valor
        }));
    };

    const generateSlug = () => {
        if (formData.nome) {
            const slug = formData.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            setFormData(prev => ({ ...prev, slug }));
        }
    };

    const resetForm = () => {
        setFormData({
            nome: '', nomeCurto: '', slug: '', imagemPerfil: '', website: '',
            email: '', emailAlternativo: '', telefone: '', telefoneAlternativo: '', whatsapp: '',
            alvara: '', nuit: '', cafe: '',
            morada: {
                rua: '', numero: '', complemento: '', bairro: '', quarteirao: '', casa: '',
                cidade: '', provincia: '', distrito: '', postoAdministrativo: '',
                pais: 'Moçambique', codigoPostal: '', coordenadas: { latitude: '', longitude: '' }
            },
            regimeIVA: 'Normal', percentagemIVA: 16, retencaoFonte: false,
            atividadesEconomicas: [],
            dadosBancarios: [{ banco: '', conta: '', nib: '', swift: '', titular: '', principal: true }],
            setorActividade: '', ramoAtividade: '',
            contactosEmergencia: [], sedes: [],
            configuracoes: {
                idioma: 'pt-PT', timezone: 'Africa/Maputo', formatoData: 'DD/MM/YYYY', formatoHora: '24h',
                moeda: { codigo: 'MZN', simbolo: 'MT', nome: 'Metical', casasDecimais: 2 },
                formatoNumero: { separadorDecimal: ',', separadorMilhar: '.' },
                tema: { corPrimaria: '#6C9BCF' },
                modulosAtivos: { ...estruturaBaseModulos }
            },
            plano: {
                tipo: 'Trial', dataInicio: new Date().toISOString().split('T')[0],
                limiteUtilizadores: 1, limiteProdutos: 100, limiteArmazenamento: 100
            },
            features: [], status: 'EmAprovacao', arquivado: false
        });
        setTempImagePreview(null);
        setCreateMessage({ text: '', type: '' });
        setActiveModalTab('geral');
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    // ==============================================
    // 🔥 FUNÇÃO CORRIGIDA: CRIAR EMPRESA + LICENÇA
    // ==============================================
    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        setCreateLoading(true);
        setCreateMessage({ text: '', type: '' });

        if (!formData.nome.trim()) {
            setCreateMessage({ text: 'O nome da empresa é obrigatório', type: 'danger' });
            setCreateLoading(false);
            return;
        }
        if (!formData.email.trim()) {
            setCreateMessage({ text: 'O email é obrigatório', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setCreateMessage({ text: 'Email inválido', type: 'danger' });
            setCreateLoading(false);
            return;
        }

        if (!formData.slug && formData.nome) generateSlug();

        const userId = getCurrentUserId();

        const dadosParaEnviar = processFormData({
            ...formData,
            criadoPor: userId,
            criadoEm: new Date().toISOString(),
            actualizadoEm: new Date().toISOString()
        });

        const { plano, ...dadosEmpresa } = dadosParaEnviar;

        try {
            const response = await api.post('/empresas', dadosEmpresa);

            if (response.data.success) {
                const empresaId = response.data.data._id || response.data.data.id;
                console.log('✅ Empresa criada com sucesso! ID:', empresaId);
                console.log('📝 Registro: criada pelo utilizador', userId);

                try {
                    const licencaPayload = {
                        empresaId: empresaId,
                        chave: generateLicencaKey(),
                        tipoPrazo: formData.plano.tipo === 'Trial' ? 'Mensal' : 'Mensal',
                        dataFim: null,
                        plano: formData.plano.tipo || 'Trial',
                        limiteUtilizadores: parseInt(formData.plano.limiteUtilizadores) || 1,
                        limiteProdutos: parseInt(formData.plano.limiteProdutos) || 100,
                        ativa: true
                    };

                    console.log('📦 A criar licença com payload:', licencaPayload);

                    const licencaResponse = await api.post('/licencas', licencaPayload);

                    if (licencaResponse.data && (licencaResponse.data._id || licencaResponse.data.id)) {
                        console.log('✅ Licença criada com sucesso!');
                    } else {
                        console.warn('⚠️ Licença criada mas resposta inesperada:', licencaResponse.data);
                    }
                } catch (licErr) {
                    console.error('❌ Erro ao criar licença:', licErr);
                    console.error('❌ Detalhes:', licErr.response?.data);
                }

                setCreateMessage({ text: 'Empresa criada com sucesso!', type: 'success' });
                setTimeout(() => {
                    setShowCreateModal(false);
                    resetForm();
                    carregarEmpresasComForca();
                    setMessage({ text: 'Empresa criada com sucesso!', type: 'success' });
                    setTimeout(() => setMessage({ text: '', type: '' }), 3000);
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao criar empresa:', err);
            setCreateMessage({ text: err.response?.data?.erro || 'Erro ao criar empresa', type: 'danger' });
        } finally {
            setCreateLoading(false);
        }
    };

    // ==============================================
    // FUNÇÕES DE EDIÇÃO
    // ==============================================
    const loadEmpresaForEdit = async (empresa) => {
        setEditLoading(true);
        setIsEditingLicenca(false);
        setLicencaData(null);
        setLicencaMessage({ text: '', type: '' });

        try {
            console.log('📡 Carregando empresa para edição:', empresa._id);

            const response = await api.get(`/empresas/${empresa._id}`);
            const empresaCompleta = response.data.data;
            console.log('✅ Empresa carregada:', empresaCompleta.nome);

            let dadosBancariosProcessados = [];
            if (empresaCompleta.dadosBancarios && Array.isArray(empresaCompleta.dadosBancarios)) {
                dadosBancariosProcessados = empresaCompleta.dadosBancarios.map(bancario => ({
                    banco: bancario?.banco || '',
                    conta: bancario?.conta || '',
                    nib: bancario?.nib || '',
                    swift: bancario?.swift || '',
                    titular: bancario?.titular || empresaCompleta.nome || '',
                    principal: bancario?.principal !== undefined ? bancario.principal : false
                }));
            } else {
                dadosBancariosProcessados = [{ banco: '', conta: '', nib: '', swift: '', titular: '', principal: true }];
            }

            let modulosAtivos = empresaCompleta.configuracoes?.modulosAtivos || {};
            modulosAtivos = converterModulosAntigosParaNovos(modulosAtivos);

            const corPrimaria = empresaCompleta.configuracoes?.tema?.corPrimaria || '#6C9BCF';

            console.log('🎨 Cor primária carregada da empresa:', corPrimaria);

            const editData = {
                _id: empresaCompleta._id,
                nome: empresaCompleta.nome || '',
                nomeCurto: empresaCompleta.nomeCurto || '',
                slug: empresaCompleta.slug || '',
                imagemPerfil: empresaCompleta.imagemPerfil || '',
                website: empresaCompleta.website || '',
                email: empresaCompleta.email || '',
                emailAlternativo: empresaCompleta.emailAlternativo || '',
                telefone: empresaCompleta.telefone || '',
                telefoneAlternativo: empresaCompleta.telefoneAlternativo || '',
                whatsapp: empresaCompleta.whatsapp || '',
                alvara: empresaCompleta.alvara || '',
                nuit: empresaCompleta.nuit || '',
                cafe: empresaCompleta.cafe || '',
                morada: {
                    rua: empresaCompleta.morada?.rua || '',
                    numero: empresaCompleta.morada?.numero || '',
                    complemento: empresaCompleta.morada?.complemento || '',
                    bairro: empresaCompleta.morada?.bairro || '',
                    quarteirao: empresaCompleta.morada?.quarteirao || '',
                    casa: empresaCompleta.morada?.casa || '',
                    cidade: empresaCompleta.morada?.cidade || '',
                    provincia: empresaCompleta.morada?.provincia || '',
                    distrito: empresaCompleta.morada?.distrito || '',
                    postoAdministrativo: empresaCompleta.morada?.postoAdministrativo || '',
                    pais: empresaCompleta.morada?.pais || 'Moçambique',
                    codigoPostal: empresaCompleta.morada?.codigoPostal || '',
                    coordenadas: {
                        latitude: empresaCompleta.morada?.coordenadas?.latitude || '',
                        longitude: empresaCompleta.morada?.coordenadas?.longitude || ''
                    }
                },
                regimeIVA: empresaCompleta.regimeIVA || 'Normal',
                percentagemIVA: empresaCompleta.percentagemIVA !== undefined && empresaCompleta.percentagemIVA !== null
                    ? empresaCompleta.percentagemIVA
                    : 16,
                retencaoFonte: empresaCompleta.retencaoFonte || false,
                atividadesEconomicas: empresaCompleta.atividadesEconomicas || [],
                dadosBancarios: dadosBancariosProcessados,
                setorActividade: empresaCompleta.setorActividade || '',
                ramoAtividade: empresaCompleta.ramoAtividade || '',
                contactosEmergencia: empresaCompleta.contactosEmergencia || [],
                sedes: empresaCompleta.sedes || [],
                configuracoes: {
                    idioma: empresaCompleta.configuracoes?.idioma || 'pt-PT',
                    timezone: empresaCompleta.configuracoes?.timezone || 'Africa/Maputo',
                    formatoData: empresaCompleta.configuracoes?.formatoData || 'DD/MM/YYYY',
                    formatoHora: empresaCompleta.configuracoes?.formatoHora || '24h',
                    moeda: {
                        codigo: empresaCompleta.configuracoes?.moeda?.codigo || 'MZN',
                        simbolo: empresaCompleta.configuracoes?.moeda?.simbolo || 'MT',
                        nome: empresaCompleta.configuracoes?.moeda?.nome || 'Metical',
                        casasDecimais: empresaCompleta.configuracoes?.moeda?.casasDecimais || 2
                    },
                    formatoNumero: {
                        separadorDecimal: empresaCompleta.configuracoes?.formatoNumero?.separadorDecimal || ',',
                        separadorMilhar: empresaCompleta.configuracoes?.formatoNumero?.separadorMilhar || '.'
                    },
                    tema: {
                        corPrimaria: corPrimaria
                    },
                    modulosAtivos: modulosAtivos
                },
                plano: {
                    tipo: empresaCompleta.plano?.tipo || 'Trial',
                    dataInicio: empresaCompleta.plano?.dataInicio ? new Date(empresaCompleta.plano.dataInicio).toISOString().split('T')[0] : new Date().toISOString().split('T')[0],
                    limiteUtilizadores: empresaCompleta.plano?.limiteUtilizadores || 1,
                    limiteProdutos: empresaCompleta.plano?.limiteProdutos || 100,
                    limiteArmazenamento: empresaCompleta.plano?.limiteArmazenamento || 100
                },
                features: empresaCompleta.features || [],
                status: empresaCompleta.status || 'EmAprovacao',
                arquivado: empresaCompleta.arquivado || false
            };

            setEditFormData(editData);
            setActiveModalTab('geral');
            setEditMessage({ text: '', type: '' });

            console.log('📡 Carregando licença da empresa:', empresa._id);
            await carregarLicenca(empresa._id);
            await carregarLimiteUtilizadores(empresa._id);

            setShowEditModal(true);

        } catch (error) {
            console.error('❌ Erro ao carregar empresa:', error);
            setEditMessage({ text: error.response?.data?.erro || 'Erro ao carregar dados da empresa', type: 'danger' });
        } finally {
            setEditLoading(false);
        }
    };

    const handleEditChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        if (name.includes('.')) {
            const parts = name.split('.');
            if (parts.length === 2) {
                setEditFormData(prev => ({ ...prev, [parts[0]]: { ...prev[parts[0]], [parts[1]]: newValue } }));
            } else if (parts.length === 3) {
                setEditFormData(prev => ({
                    ...prev,
                    [parts[0]]: { ...prev[parts[0]], [parts[1]]: { ...prev[parts[0]][parts[1]], [parts[2]]: newValue } }
                }));
            } else if (parts.length === 4) {
                setEditFormData(prev => ({
                    ...prev,
                    [parts[0]]: {
                        ...prev[parts[0]],
                        [parts[1]]: {
                            ...prev[parts[0]]?.[parts[1]],
                            [parts[2]]: newValue
                        }
                    }
                }));
            }
        } else {
            setEditFormData(prev => ({ ...prev, [name]: newValue }));
        }
    };

    const handleEditIVAChange = (e) => {
        const valor = parseInt(e.target.value);
        setEditFormData(prev => ({ ...prev, percentagemIVA: valor }));
    };

    const generateEditSlug = () => {
        if (editFormData?.nome) {
            const slug = editFormData.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            setEditFormData(prev => ({ ...prev, slug }));
        }
    };

    const resetEditForm = () => {
        if (selectedEmpresa) {
            loadEmpresaForEdit(selectedEmpresa);
        }
        setEditMessage({ text: '', type: '' });
        setLicencaMessage({ text: '', type: '' });
        setIsEditingLicenca(false);
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA SALVAR COR NO BACKEND
    // ==============================================
    const salvarCorNoBackend = async (empresaId, corPrimaria) => {
        try {
            console.log('🎨 A salvar cor primária no backend:', corPrimaria);

            const responseGet = await api.get(`/empresas/${empresaId}`);
            if (!responseGet.data || !responseGet.data.success) {
                throw new Error('Erro ao carregar dados da empresa');
            }

            const empresaAtual = responseGet.data.data;

            const payload = {
                configuracoes: {
                    ...empresaAtual.configuracoes,
                    tema: {
                        corPrimaria: corPrimaria
                    }
                }
            };

            console.log('📤 Payload para atualizar cor:', payload);

            const response = await api.put(`/empresas/${empresaId}`, payload);

            if (response.data && response.data.success) {
                console.log('✅ Cor primária salva com sucesso no backend!');

                window.dispatchEvent(new CustomEvent('coresAtualizadas', {
                    detail: {
                        empresaId: empresaId,
                        corPrimaria: corPrimaria,
                        source: 'Empresas.js'
                    }
                }));

                setEditFormData(prev => ({
                    ...prev,
                    configuracoes: {
                        ...prev?.configuracoes,
                        tema: {
                            corPrimaria: corPrimaria
                        }
                    }
                }));

                return true;
            } else {
                throw new Error(response.data?.erro || 'Erro ao salvar cor');
            }
        } catch (err) {
            console.error('❌ Erro ao salvar cor no backend:', err);
            throw err;
        }
    };

    // ==============================================
    // 🔥 FUNÇÃO PARA ATUALIZAR COR PRIMÁRIA
    // ==============================================
    const handleCorPrimariaChange = (cor) => {
        if (!editFormData) return;

        setEditFormData(prev => ({
            ...prev,
            configuracoes: {
                ...prev.configuracoes,
                tema: {
                    corPrimaria: cor
                }
            }
        }));

        const empresaId = editFormData._id || selectedEmpresa?._id;
        if (empresaId) {
            salvarCorNoBackend(empresaId, cor)
                .then(() => {
                    setEditMessage({ text: 'Cor primária atualizada com sucesso!', type: 'success' });
                    setTimeout(() => setEditMessage({ text: '', type: '' }), 2000);
                })
                .catch((err) => {
                    setEditMessage({ text: err.message || 'Erro ao salvar cor', type: 'danger' });
                    setTimeout(() => setEditMessage({ text: '', type: '' }), 3000);
                });
        }
    };

    // ==============================================
    // 🔥 FUNÇÃO CORRIGIDA: handleEditSubmit
    // ==============================================
    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setEditLoading(true);
        setEditMessage({ text: '', type: '' });

        if (!editFormData.nome.trim()) {
            setEditMessage({ text: 'O nome da empresa é obrigatório', type: 'danger' });
            setEditLoading(false);
            return;
        }
        if (!editFormData.email.trim()) {
            setEditMessage({ text: 'O email é obrigatório', type: 'danger' });
            setEditLoading(false);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(editFormData.email)) {
            setEditMessage({ text: 'Email inválido', type: 'danger' });
            setEditLoading(false);
            return;
        }

        if (!editFormData.slug && editFormData.nome) generateEditSlug();

        const wasArchived = selectedEmpresa?.arquivado;
        const willBeArchived = editFormData.arquivado;
        const statusChanged = wasArchived !== willBeArchived;

        let dadosParaEnviar = processFormData({
            ...editFormData,
            actualizadoEm: new Date().toISOString()
        });

        delete dadosParaEnviar._id;

        if (dadosParaEnviar.arquivado === true) {
            dadosParaEnviar.status = 'Suspensa';
            dadosParaEnviar.dataArquivo = new Date();
            dadosParaEnviar.motivoArquivo = 'Arquivado pelo utilizador';
        } else {
            dadosParaEnviar.status = 'Ativa';
            dadosParaEnviar.dataArquivo = null;
            dadosParaEnviar.motivoArquivo = null;
        }

        dadosParaEnviar.arquivado = Boolean(dadosParaEnviar.arquivado);

        if (editFormData.configuracoes?.tema) {
            dadosParaEnviar.configuracoes = {
                ...dadosParaEnviar.configuracoes,
                tema: {
                    corPrimaria: editFormData.configuracoes.tema.corPrimaria || '#6C9BCF'
                }
            };
        }

        if (dadosParaEnviar.dadosBancarios && Array.isArray(dadosParaEnviar.dadosBancarios)) {
            const bancariosFiltrados = dadosParaEnviar.dadosBancarios.filter(b =>
                b.banco || b.conta || b.nib || b.swift || b.titular
            );

            if (bancariosFiltrados.length > 0) {
                const hasPrincipal = bancariosFiltrados.some(b => b.principal === true);
                if (!hasPrincipal && bancariosFiltrados.length > 0) {
                    bancariosFiltrados[0].principal = true;
                }
                dadosParaEnviar.dadosBancarios = bancariosFiltrados;
            } else {
                dadosParaEnviar.dadosBancarios = [];
            }
        } else {
            dadosParaEnviar.dadosBancarios = [];
        }

        try {
            console.log('🔄 Atualizando empresa:', selectedEmpresa._id);
            console.log('📦 Dados a enviar:', dadosParaEnviar);
            console.log(`📊 Arquivo: ${wasArchived} -> ${willBeArchived}`);
            console.log(`📊 Status: ${selectedEmpresa?.status} -> ${dadosParaEnviar.status}`);

            const response = await api.put(`/empresas/${selectedEmpresa._id}`, dadosParaEnviar);

            if (response.data.success) {
                console.log('✅ Empresa atualizada com sucesso!');

                if (editFormData.configuracoes?.tema?.corPrimaria) {
                    window.dispatchEvent(new CustomEvent('coresAtualizadas', {
                        detail: {
                            empresaId: selectedEmpresa._id,
                            corPrimaria: editFormData.configuracoes.tema.corPrimaria,
                            source: 'Empresas.js'
                        }
                    }));
                }

                if (statusChanged) {
                    console.log(`🔄 Status da empresa mudou: ${wasArchived ? 'Arquivada' : 'Ativa'} -> ${willBeArchived ? 'Arquivada' : 'Ativa'}`);

                    try {
                        const usersResponse = await api.get(`/empresas/${selectedEmpresa._id}/utilizadores`);
                        const usersToUpdate = usersResponse.data.data || [];
                        console.log(`👥 Encontrados ${usersToUpdate.length} utilizadores para atualizar`);

                        let successCount = 0;
                        let failCount = 0;

                        for (const user of usersToUpdate) {
                            try {
                                const userId = user.userId || user._id;
                                console.log(`🔄 ${willBeArchived ? 'Desativando' : 'Reativando'} utilizador ${user.nome}`);

                                const updateResponse = await api.put(`/empresas/${selectedEmpresa._id}/utilizadores/${userId}/active`, {
                                    isActive: !willBeArchived
                                });

                                if (updateResponse.data && updateResponse.data.success !== false) {
                                    console.log(`✅ Utilizador ${user.nome} ${willBeArchived ? 'desativado' : 'reativado'} com sucesso!`);
                                    successCount++;
                                } else {
                                    console.error(`❌ Falha ao ${willBeArchived ? 'desativar' : 'reativar'} utilizador ${user.nome}`);
                                    failCount++;
                                }
                            } catch (userErr) {
                                console.error(`❌ Erro ao ${willBeArchived ? 'desativar' : 'reativar'} utilizador ${user.nome}:`, userErr.response?.data || userErr.message);
                                failCount++;
                            }
                        }

                        window.dispatchEvent(new CustomEvent('utilizadoresAtualizados', {
                            detail: {
                                empresaId: selectedEmpresa._id,
                                action: willBeArchived ? 'archive' : 'unarchive',
                                usersUpdated: usersToUpdate.length,
                                successCount: successCount,
                                failCount: failCount,
                                timestamp: Date.now()
                            }
                        }));

                        if (failCount > 0) {
                            setEditMessage({
                                text: `Empresa atualizada, mas ${failCount} utilizador(es) não foram ${willBeArchived ? 'desativados' : 'reativados'}.`,
                                type: 'warning'
                            });
                        }
                    } catch (usersErr) {
                        console.error('❌ Erro ao atualizar utilizadores:', usersErr);
                        setEditMessage({
                            text: 'Empresa atualizada, mas houve erro ao atualizar os utilizadores.',
                            type: 'warning'
                        });
                    }

                    try {
                        const licencaResponse = await api.get(`/licencas/empresa/${selectedEmpresa._id}`);
                        let licenca = null;

                        if (licencaResponse.data && licencaResponse.data.licenca) {
                            licenca = licencaResponse.data.licenca;
                        } else if (licencaResponse.data && licencaResponse.data.data) {
                            licenca = licencaResponse.data.data;
                        } else if (licencaResponse.data && licencaResponse.data._id) {
                            licenca = licencaResponse.data;
                        }

                        if (licenca && licenca._id && licenca.chave !== 'SEM-LICENCA' && licenca.chave !== 'ERROR-LICENCA') {
                            console.log(`🔄 Atualizando licença ${licenca.chave} para ${willBeArchived ? 'inativa' : 'ativa'}`);

                            await api.put(`/licencas/${licenca._id}`, {
                                ativa: !willBeArchived,
                                arquivado: willBeArchived,
                                empresaId: selectedEmpresa._id
                            });
                            console.log(`✅ Licença ${willBeArchived ? 'arquivada' : 'restaurada'} com sucesso`);
                        }
                    } catch (licErr) {
                        console.error('❌ Erro ao atualizar licença:', licErr);
                    }
                }

                if (isEditingLicenca) {
                    await salvarLicenca();
                }

                if (!editMessage.text || editMessage.type !== 'warning') {
                    setEditMessage({
                        text: willBeArchived ? 'Empresa arquivada com sucesso!' : 'Empresa restaurada com sucesso!',
                        type: 'success'
                    });
                }

                setTimeout(() => {
                    setShowEditModal(false);
                    setEditFormData(null);
                    setLicencaData(null);
                    setIsEditingLicenca(false);
                    carregarEmpresasComForca();
                    setMessage({
                        text: editMessage.text || (willBeArchived ? 'Empresa arquivada com sucesso!' : 'Empresa restaurada com sucesso!'),
                        type: editMessage.type || 'success'
                    });
                    setTimeout(() => setMessage({ text: '', type: '' }), 3000);
                }, 1500);
            }
        } catch (err) {
            console.error('❌ Erro ao atualizar empresa:', err);
            setEditMessage({ text: err.response?.data?.erro || 'Erro ao atualizar empresa', type: 'danger' });
        } finally {
            setEditLoading(false);
        }
    };

    // ==============================================
    // FUNÇÕES DE EXCLUSÃO
    // ==============================================
    const openDeleteModal = (empresa) => {
        setEmpresaToDelete(empresa);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
        setEmpresaToDelete(null);
    };

    const confirmArchive = async () => {
        if (!empresaToDelete) return;
        setDeleting(true);
        console.log(`📦 Arquivando empresa: ${empresaToDelete.nome}`);

        try {
            let usersToUpdate = [];
            try {
                const usersResponse = await api.get(`/empresas/${empresaToDelete._id}/utilizadores`);
                usersToUpdate = usersResponse.data.data || [];
                console.log(`👥 Encontrados ${usersToUpdate.length} utilizadores para desativar`);
            } catch (usersErr) {
                console.error('❌ Erro ao buscar utilizadores:', usersErr);
            }

            const response = await api.put(`/empresas/${empresaToDelete._id}`, {
                arquivado: true,
                status: 'Suspensa'
            });

            if (response.data.success) {
                console.log('✅ Empresa arquivada com sucesso!');

                let successCount = 0;
                let failCount = 0;

                for (const user of usersToUpdate) {
                    try {
                        const userId = user.userId || user._id;
                        console.log(`🔄 Desativando utilizador ${user.nome}`);

                        const updateResponse = await api.put(`/empresas/${empresaToDelete._id}/utilizadores/${userId}/active`, {
                            isActive: false
                        });

                        if (updateResponse.data && updateResponse.data.success !== false) {
                            console.log(`✅ Utilizador ${user.nome} desativado com sucesso!`);
                            successCount++;
                        } else {
                            console.error(`❌ Falha ao desativar utilizador ${user.nome}`);
                            failCount++;
                        }
                    } catch (userErr) {
                        console.error(`❌ Erro ao desativar utilizador ${user.nome}:`, userErr.response?.data || userErr.message);
                        failCount++;
                    }
                }

                if (failCount > 0) {
                    setMessage({
                        text: `Empresa "${empresaToDelete.nome}" arquivada, mas ${failCount} utilizador(es) não foram desativados.`,
                        type: 'warning'
                    });
                } else {
                    setMessage({
                        text: `Empresa "${empresaToDelete.nome}" arquivada e ${successCount} utilizador(es) desativado(s) com sucesso!`,
                        type: 'success'
                    });
                }

                closeDeleteModal();
                carregarEmpresasComForca();

                window.dispatchEvent(new CustomEvent('utilizadoresAtualizados', {
                    detail: {
                        empresaId: empresaToDelete._id,
                        action: 'archive',
                        usersUpdated: usersToUpdate.length,
                        successCount: successCount,
                        failCount: failCount,
                        timestamp: Date.now()
                    }
                }));

                setTimeout(() => setMessage({ text: '', type: '' }), 5000);
            }
        } catch (err) {
            console.error('❌ Erro ao arquivar empresa:', err);
            setMessage({ text: err.response?.data?.erro || 'Erro ao arquivar empresa', type: 'danger' });
            closeDeleteModal();
        } finally {
            setDeleting(false);
        }
    };

    const confirmDeletePermanent = async () => {
        if (!empresaToDelete) return;
        setDeleting(true);
        console.log(`🗑️ Eliminando permanentemente empresa: ${empresaToDelete.nome}`);

        try {
            const response = await api.delete(`/empresas/${empresaToDelete._id}`);

            if (response.data.success) {
                console.log('✅ Empresa eliminada permanentemente!');

                const utilizadoresRemovidos = response.data.data?.utilizadoresRemovidos || 0;
                const mensagem = `✅ Empresa "${empresaToDelete.nome}" eliminada permanentemente! ${utilizadoresRemovidos > 0 ? `${utilizadoresRemovidos} utilizador(es) desassociado(s).` : ''}`;

                setMessage({ text: mensagem, type: 'success' });
                closeDeleteModal();

                window.dispatchEvent(new CustomEvent('empresaEliminada', {
                    detail: {
                        empresaId: empresaToDelete._id,
                        nome: empresaToDelete.nome,
                        utilizadoresRemovidos: utilizadoresRemovidos,
                        timestamp: Date.now()
                    }
                }));

                await carregarEmpresasComForca();
                setTimeout(() => setMessage({ text: '', type: '' }), 5000);
            }
        } catch (err) {
            console.error('❌ Erro ao eliminar empresa:', err);
            setMessage({
                text: err.response?.data?.erro || 'Erro ao eliminar empresa',
                type: 'danger'
            });
            closeDeleteModal();
        } finally {
            setDeleting(false);
        }
    };

    const handleEdit = (empresa) => {
        setSelectedEmpresa(empresa);
        loadEmpresaForEdit(empresa);
    };

    const getIVADescription = (percentagem) => {
        const opcao = opcoesIVA.find(opt => opt.valor === percentagem);
        if (opcao?.valor === 0) return 'Empresa isenta de IVA';
        if (opcao?.valor === 5) return 'IVA 5% - Trimestral';
        if (opcao?.valor === 15) return 'IVA 15% - Trimestral';
        if (opcao?.valor === 16) return 'IVA 16% - Mensal';
        return '';
    };

    const logoPreview = tempImagePreview || (formData.imagemPerfil ? getImagemUrl(formData.imagemPerfil) : null);
    const editLogoPreview = editFormData?.imagemPerfil ? getImagemUrl(editFormData.imagemPerfil) : null;

    const getStatusBadge = (status) => {
        const statusConfig = {
            'Ativa': { class: 'status-active', icon: 'check_circle' },
            'Suspensa': { class: 'status-suspended', icon: 'warning' },
            'Cancelada': { class: 'status-canceled', icon: 'cancel' },
            'EmAprovacao': { class: 'status-pending', icon: 'pending' }
        };
        const config = statusConfig[status] || statusConfig['EmAprovacao'];
        return (
            <span className={`status-badge ${config.class}`}>
                <Icon name={config.icon} size={12} /> {status === 'EmAprovacao' ? 'Em Aprovação' : status}
            </span>
        );
    };

    const getPlanoBadge = (empresa) => {
        const planoNome = empresa?.licenca?.plano || empresa?.plano?.tipo || 'Trial';

        const planoConfig = {
            'Trial': { class: 'plano-trial', icon: 'science' },
            'Basico': { class: 'plano-basico', icon: 'star' },
            'Profissional': { class: 'plano-profissional', icon: 'stars' },
            'Enterprise': { class: 'plano-enterprise', icon: 'workspace_premium' },
            'Personalizado': { class: 'plano-personalizado', icon: 'build' },
            'Custom': { class: 'plano-personalizado', icon: 'build' }
        };
        const config = planoConfig[planoNome] || planoConfig['Trial'];
        return (
            <span className={`plano-badge ${config.class}`}>
                <Icon name={config.icon} size={12} /> {planoNome}
            </span>
        );
    };


    // ==============================================
// RENDERIZAÇÃO DA TAB DE CRIAÇÃO
// ==============================================
const renderTabContent = () => {
    switch (activeModalTab) {
        case 'geral':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group">
                        <label>Nome da Empresa <span className="empresas-required">*</span></label>
                        <input type="text" name="nome" value={formData.nome} onChange={handleChange} onBlur={generateSlug} required placeholder="Ex: Empresa Principal" />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Nome Curto</label>
                            <input type="text" name="nomeCurto" value={formData.nomeCurto} onChange={handleChange} placeholder="Ex: Principal" />
                        </div>
                        <div className="empresas-form-group">
                            <label>Slug</label>
                            <input type="text" name="slug" value={formData.slug} onChange={handleChange} placeholder="empresa-principal" />
                        </div>
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Email Alternativo</label>
                            <input type="email" name="emailAlternativo" value={formData.emailAlternativo} onChange={handleChange} placeholder="alternativo@empresa.com" />
                        </div>
                        <div className="empresas-form-group">
                            <label>Alvará</label>
                            <input type="text" name="alvara" value={formData.alvara} onChange={handleChange} placeholder="Número do Alvará" />
                        </div>
                    </div>
                    <div className="empresas-form-group">
                        <label>Website</label>
                        <input type="url" name="website" value={formData.website} onChange={handleChange} placeholder="https://www.empresa.com" />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Setor de Atividade</label>
                            <select name="setorActividade" value={formData.setorActividade} onChange={handleChange}>
                                <option value="">Selecione</option>
                                {setoresAtividade.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                        </div>
                        <div className="empresas-form-group">
                            <label>Ramo de Atividade</label>
                            <input type="text" name="ramoAtividade" value={formData.ramoAtividade} onChange={handleChange} placeholder="Ex: Comércio de produtos" />
                        </div>
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Status</label>
                            <select name="status" value={formData.status} onChange={handleChange}>
                                {statusOptions.map(s => <option key={s} value={s}>{s === 'EmAprovacao' ? 'Em Aprovação' : s}</option>)}
                            </select>
                        </div>
                        <div className="empresas-form-group empresas-checkbox-group">
                            <label>
                                <input type="checkbox" name="arquivado" checked={formData.arquivado} onChange={handleChange} /> Arquivar empresa
                            </label>
                        </div>
                    </div>
                </div>
            );

        case 'logo':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-modal-logo-container">
                        <div className="empresas-modal-logo-preview">
                            {logoPreview ? <img src={logoPreview} alt="Logo" /> : <Icon name="image" size={48} />}
                        </div>
                        <div className="empresas-modal-logo-actions">
                            <input type="file" ref={fileInputRef} accept="image/jpeg,image/png,image/jpg,image/svg+xml,image/webp" onChange={handleImageSelect} style={{ display: 'none' }} id="logo-upload" />
                            <label htmlFor="logo-upload" className="empresas-upload-btn">
                                <Icon name="cloud_upload" size={16} /> Selecionar Imagem
                            </label>
                            {formData.imagemPerfil && (
                                <button className="empresas-clear-btn" onClick={removeImage}>
                                    <Icon name="delete" size={16} /> Remover
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            );

        case 'fiscal':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group">
                        <label>NUIT</label>
                        <input type="text" name="nuit" value={formData.nuit} onChange={handleChange} placeholder="NUIT" />
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Código de autorização para faturação eletrónica (CAFE)</label>
                        <input
                            type="text"
                            name="cafe"
                            value={formData.cafe}
                            onChange={handleChange}
                            placeholder="Ex: CAFE-XXXX-XXXX-XXXX"
                            className="empresas-input-cafe"
                        />
                        <small className="empresas-form-hint">
                            <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                            Código fornecido pela Autoridade Tributária para faturação eletrónica.
                            Este código será exibido em faturas, recibos e orçamentos.
                        </small>
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Percentagem de IVA</label>
                        <select value={formData.percentagemIVA} onChange={handleIVAChange}>
                            {opcoesIVA.map(op => <option key={op.valor} value={op.valor}>{op.label}</option>)}
                        </select>
                        <small>{getIVADescription(formData.percentagemIVA)}</small>
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Regime de IVA</label>
                        <select name="regimeIVA" value={formData.regimeIVA} onChange={handleChange}>
                            {regimesIVA.map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                    </div>
                    <div className="empresas-checkbox-group">
                        <label>
                            <input type="checkbox" name="retencaoFonte" checked={formData.retencaoFonte} onChange={handleChange} />
                            Aplicar Retenção na Fonte
                        </label>
                    </div>
                </div>
            );

        case 'morada':
            return (
                <div className="empresas-modal-section-morada">
                    <div className="empresas-form-row">
                        <input type="text" name="morada.rua" value={formData.morada.rua} onChange={handleChange} placeholder="Rua" />
                        <input type="text" name="morada.numero" value={formData.morada.numero} onChange={handleChange} placeholder="Número" />
                    </div>
                    <div className="empresas-form-row">
                        <input type="text" name="morada.complemento" value={formData.morada.complemento} onChange={handleChange} placeholder="Complemento" />
                        <input type="text" name="morada.bairro" value={formData.morada.bairro} onChange={handleChange} placeholder="Bairro" />
                    </div>
                    <div className="empresas-form-row">
                        <input type="text" name="morada.quarteirao" value={formData.morada.quarteirao} onChange={handleChange} placeholder="Quarteirão" />
                        <input type="text" name="morada.casa" value={formData.morada.casa} onChange={handleChange} placeholder="Casa" />
                    </div>
                    <div className="empresas-form-row">
                        <input type="text" name="morada.cidade" value={formData.morada.cidade} onChange={handleChange} placeholder="Cidade" />
                        <input type="text" name="morada.provincia" value={formData.morada.provincia} onChange={handleChange} placeholder="Província" />
                    </div>
                    <div className="empresas-form-row">
                        <input type="text" name="morada.distrito" value={formData.morada.distrito} onChange={handleChange} placeholder="Distrito" />
                        <input type="text" name="morada.postoAdministrativo" value={formData.morada.postoAdministrativo} onChange={handleChange} placeholder="Posto Administrativo" />
                    </div>
                    <div className="empresas-form-row">
                        <select name="morada.pais" value={formData.morada.pais} onChange={handleChange}>
                            {paises.map(p => <option key={p} value={p}>{p}</option>)}
                        </select>
                        <input type="text" name="morada.codigoPostal" value={formData.morada.codigoPostal} onChange={handleChange} placeholder="Código Postal" />
                    </div>
                    <div className="empresas-form-row">
                        <input type="text" placeholder="Latitude" value={formData.morada.coordenadas.latitude} onChange={(e) => setFormData(prev => ({ ...prev, morada: { ...prev.morada, coordenadas: { ...prev.morada.coordenadas, latitude: e.target.value } } }))} />
                        <input type="text" placeholder="Longitude" value={formData.morada.coordenadas.longitude} onChange={(e) => setFormData(prev => ({ ...prev, morada: { ...prev.morada, coordenadas: { ...prev.morada.coordenadas, longitude: e.target.value } } }))} />
                    </div>
                </div>
            );

        case 'contacto':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group">
                        <label>Email <span className="empresas-required">*</span></label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="geral@empresa.com" />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Telefone</label>
                            <input type="tel" name="telefone" value={formData.telefone} onChange={handleChange} placeholder="+258 84 123 4567" />
                        </div>
                        <div className="empresas-form-group">
                            <label>Telefone Alternativo</label>
                            <input type="tel" name="telefoneAlternativo" value={formData.telefoneAlternativo} onChange={handleChange} placeholder="+258 84 123 4568" />
                        </div>
                    </div>
                    <div className="empresas-form-group">
                        <label>WhatsApp</label>
                        <input type="tel" name="whatsapp" value={formData.whatsapp} onChange={handleChange} placeholder="+258 84 123 4567" />
                    </div>
                </div>
            );

        case 'financeiro':
            return (
                <div className="empresas-modal-section-financeiro">
                    <div className="empresas-form-subsection-financeiro">
                        <h4>Moeda</h4>
                        <div className="empresas-form-row">
                            <input type="text" name="configuracoes.moeda.codigo" value={formData.configuracoes.moeda.codigo} onChange={handleChange} placeholder="Código" maxLength="3" />
                            <input type="text" name="configuracoes.moeda.simbolo" value={formData.configuracoes.moeda.simbolo} onChange={handleChange} placeholder="Símbolo" />
                            <input type="text" name="configuracoes.moeda.nome" value={formData.configuracoes.moeda.nome} onChange={handleChange} placeholder="Nome" />
                            <input type="number" name="configuracoes.moeda.casasDecimais" value={formData.configuracoes.moeda.casasDecimais} onChange={handleChange} min="0" max="4" />
                        </div>
                    </div>
                    <div className="empresas-form-subsection-financeiro">
                        <h4>Formato de Números</h4>
                        <div className="empresas-form-row">
                            <select name="configuracoes.formatoNumero.separadorDecimal" value={formData.configuracoes.formatoNumero.separadorDecimal} onChange={handleChange}>
                                <option value=",">Vírgula (,)</option>
                                <option value=".">Ponto (.)</option>
                            </select>
                            <select name="configuracoes.formatoNumero.separadorMilhar" value={formData.configuracoes.formatoNumero.separadorMilhar} onChange={handleChange}>
                                <option value=".">Ponto (.)</option>
                                <option value=",">Vírgula (,)</option>
                                <option value=" ">Espaço ( )</option>
                            </select>
                        </div>
                    </div>
                </div>
            );

        case 'bancario':
            return renderDadosBancarios();

        case 'sistema':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-subsection">
                        <h4><Icon name="palette" size={16} /> Tema do Sistema</h4>
                        <div className="empresas-form-group">
                            <label>Cor Primária (Header)</label>
                            <div className="empresas-cores-grid">
                                {coresPreDefinidas.map((item) => {
                                    const isSelected = formData.configuracoes.tema.corPrimaria === item.cor;
                                    const isWhite = item.cor?.toUpperCase() === '#FFFFFF' || item.cor?.toLowerCase() === '#ffffff';
                                    const brilho = calcularBrilho(item.cor);

                                    return (
                                        <button
                                            key={item.cor}
                                            type="button"
                                            className={`empresas-cor-option ${isSelected ? 'selected' : ''}`}
                                            style={{
                                                backgroundColor: item.cor,
                                                border: isWhite ? '2px solid #e0e0e0' : isSelected ? '3px solid var(--apple-blue)' : '2px solid transparent',
                                                boxShadow: isSelected ? '0 0 0 2px var(--apple-blue)' : 'none'
                                            }}
                                            onClick={() => setFormData(prev => ({
                                                ...prev,
                                                configuracoes: {
                                                    ...prev.configuracoes,
                                                    tema: { corPrimaria: item.cor }
                                                }
                                            }))}
                                            title={item.nome}
                                        >
                                            {isSelected && (
                                                <span className="empresas-cor-check" style={{ color: brilho < 128 ? '#ffffff' : '#1a1a2e' }}>✓</span>
                                            )}
                                            <span className="empresas-cor-tooltip">{item.nome}</span>
                                        </button>
                                    );
                                })}
                            </div>
                            <small className="empresas-form-hint">
                                <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                                A cor primária é usada no header do sistema. As alterações são salvas automaticamente.
                            </small>
                        </div>
                    </div>
                </div>
            );

        case 'modulos':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-info-text" style={{ marginBottom: '1rem' }}>
                        <Icon name="info" size={14} /> Selecione os módulos disponíveis para esta empresa.
                        Os utilizadores só poderão aceder aos módulos ativos.
                    </div>
                    <div className="empresas-modulos-container">
                        {renderizarModulos(
                            formData.configuracoes.modulosAtivos || {},
                            handleModuloChange,
                            setFormData,
                            formData
                        )}
                    </div>
                </div>
            );

        case 'plano':
            return renderPlanoTab();

        case 'licenca':
            return renderLicencaTab();

        default:
            return null;
    }
};

// ==============================================
// RENDERIZAÇÃO DA TAB PLANO
// ==============================================
const renderPlanoTab = () => {
    return (
        <div className="empresas-modal-section">
            <div className="empresas-info-text" style={{ marginBottom: '1rem' }}>
                <Icon name="info" size={14} /> Os limites do plano são definidos pela licença da empresa.
            </div>

            <div className="empresas-plano-limites-grid">
                <div className="empresas-plano-limite-card">
                    <div className="empresas-plano-limite-icon">
                        <Icon name="people" size={20} />
                    </div>
                    <div className="empresas-plano-limite-info">
                        <span className="empresas-plano-limite-label">Utilizadores</span>
                        <span className="empresas-plano-limite-valor">
                            {loadingLimite ? (
                                <span className="empresas-status-loading">A carregar...</span>
                            ) : (
                                `${limiteUtilizadores.utilizadoresAtuais || 0} / ${limiteUtilizadores.limite || '∞'}`
                            )}
                        </span>
                        {!loadingLimite && limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0 && (
                            <span className="empresas-plano-limite-alerta">
                                <Icon name="warning" size={12} /> Limite atingido
                            </span>
                        )}
                        {!loadingLimite && limiteUtilizadores.disponivel > 0 && limiteUtilizadores.limite > 0 && (
                            <span className="empresas-plano-limite-disponivel">
                                {limiteUtilizadores.disponivel} disponível
                            </span>
                        )}
                        {!loadingLimite && limiteUtilizadores.limite === 0 && (
                            <span className="empresas-plano-limite-sem-licenca">
                                Sem licença ativa
                            </span>
                        )}
                    </div>
                </div>

                <div className="empresas-plano-limite-card">
                    <div className="empresas-plano-limite-icon">
                        <Icon name="inventory" size={20} />
                    </div>
                    <div className="empresas-plano-limite-info">
                        <span className="empresas-plano-limite-label">Produtos</span>
                        <span className="empresas-plano-limite-valor">
                            {licencaData ? licencaData.limiteProdutos || '∞' : '-'}
                        </span>
                    </div>
                </div>
            </div>

            <div className="empresas-form-row">
                <div className="empresas-form-group">
                    <label>Plano</label>
                    <input type="text" value={licencaData?.plano || 'Sem licença'} disabled style={{ opacity: 0.7 }} />
                </div>
                <div className="empresas-form-group">
                    <label>Tipo de Licença</label>
                    <input type="text" value={licencaData?.tipoPrazo || 'N/A'} disabled style={{ opacity: 0.7 }} />
                </div>
            </div>

            {licencaData?.dataFim && (
                <div className="empresas-form-group">
                    <label>Data de Expiração</label>
                    <input type="text" value={new Date(licencaData.dataFim).toLocaleDateString('pt-PT')} disabled style={{ opacity: 0.7 }} />
                </div>
            )}

            <div className="empresas-info-text" style={{ marginTop: '1rem', fontSize: '0.6rem', color: 'var(--color-info-dark)' }}>
                <Icon name="info" size={12} /> Os limites são definidos pela licença. Para alterar, edite a licença na tab correspondente.
            </div>
        </div>
    );
};

// ==============================================
// RENDERIZAÇÃO DA TAB DE EDIÇÃO
// ==============================================
const renderEditTabContent = () => {
    if (!editFormData) return null;
    switch (activeModalTab) {
        case 'geral':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group">
                        <label>Nome da Empresa *</label>
                        <input type="text" name="nome" value={editFormData.nome} onChange={handleEditChange} onBlur={generateEditSlug} required />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group"><label>Nome Curto</label><input type="text" name="nomeCurto" value={editFormData.nomeCurto} onChange={handleEditChange} /></div>
                        <div className="empresas-form-group"><label>Slug</label><input type="text" name="slug" value={editFormData.slug} onChange={handleEditChange} /></div>
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group"><label>Email Alternativo</label><input type="email" name="emailAlternativo" value={editFormData.emailAlternativo} onChange={handleEditChange} /></div>
                        <div className="empresas-form-group"><label>Alvará</label><input type="text" name="alvara" value={editFormData.alvara} onChange={handleEditChange} /></div>
                    </div>
                    <div className="empresas-form-group"><label>Website</label><input type="url" name="website" value={editFormData.website} onChange={handleEditChange} /></div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Setor de Atividade</label>
                            <select name="setorActividade" value={editFormData.setorActividade} onChange={handleEditChange}>
                                <option value="">Selecione</option>
                                {setoresAtividade.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                        </div>
                        <div className="empresas-form-group"><label>Ramo de Atividade</label><input type="text" name="ramoAtividade" value={editFormData.ramoAtividade} onChange={handleEditChange} /></div>
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Status</label>
                            <select name="status" value={editFormData.status} onChange={handleEditChange}>
                                {statusOptions.map(s => <option key={s} value={s}>{s === 'EmAprovacao' ? 'Em Aprovação' : s}</option>)}
                            </select>
                        </div>
                        <div className="empresas-checkbox-group">
                            <label>
                                <input type="checkbox" name="arquivado" checked={editFormData.arquivado} onChange={handleEditChange} /> Arquivar
                            </label>
                        </div>
                    </div>
                </div>
            );

        case 'logo':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-modal-logo-container">
                        <div className="empresas-modal-logo-preview">
                            {editLogoPreview ? <img src={editLogoPreview} alt="Logo" /> : <Icon name="image" size={48} />}
                        </div>
                        <div className="empresas-modal-logo-actions">
                            <input type="file" ref={editFileInputRef} accept="image/jpeg,image/png,image/jpg,image/svg+xml,image/webp" onChange={handleEditImageUpload} style={{ display: 'none' }} id="edit-logo-upload" />
                            <label htmlFor="edit-logo-upload" className="empresas-upload-btn">
                                <Icon name="cloud_upload" size={16} /> Selecionar Imagem
                            </label>
                            {editFormData.imagemPerfil && (
                                <button className="empresas-clear-btn" onClick={removeEditImage}>
                                    <Icon name="delete" size={16} /> Remover
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            );

        case 'fiscal':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group">
                        <label>NUIT</label>
                        <input type="text" name="nuit" value={editFormData.nuit} onChange={handleEditChange} placeholder="NUIT" />
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Código de autorização para faturação eletrónica (CAFE)</label>
                        <input
                            type="text"
                            name="cafe"
                            value={editFormData.cafe}
                            onChange={handleEditChange}
                            placeholder="Ex: CAFE-XXXX-XXXX-XXXX"
                            className="empresas-input-cafe"
                        />
                        <small className="empresas-form-hint">
                            <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                            Código fornecido pela Autoridade Tributária para faturação eletrónica.
                            Este código será exibido em faturas, recibos e orçamentos.
                        </small>
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Percentagem de IVA</label>
                        <select value={editFormData.percentagemIVA} onChange={handleEditIVAChange}>
                            {opcoesIVA.map(op => <option key={op.valor} value={op.valor}>{op.label}</option>)}
                        </select>
                        <small>{getIVADescription(editFormData.percentagemIVA)}</small>
                    </div>
                    <div className="empresas-form-group" style={{ marginTop: '0.75rem' }}>
                        <label>Regime de IVA</label>
                        <select name="regimeIVA" value={editFormData.regimeIVA} onChange={handleEditChange}>
                            {regimesIVA.map(r => <option key={r} value={r}>{r}</option>)}
                        </select>
                    </div>
                    <div className="empresas-checkbox-group" style={{ marginTop: '0.75rem' }}>
                        <label>
                            <input type="checkbox" name="retencaoFonte" checked={editFormData.retencaoFonte} onChange={handleEditChange} />
                            Retenção na Fonte
                        </label>
                    </div>
                </div>
            );

        case 'morada':
            return (
                <div className="empresas-modal-section-morada">
                    <div className="empresas-form-row"><input type="text" name="morada.rua" value={editFormData.morada.rua} onChange={handleEditChange} placeholder="Rua" /><input type="text" name="morada.numero" value={editFormData.morada.numero} onChange={handleEditChange} placeholder="Número" /></div>
                    <div className="empresas-form-row"><input type="text" name="morada.complemento" value={editFormData.morada.complemento} onChange={handleEditChange} placeholder="Complemento" /><input type="text" name="morada.bairro" value={editFormData.morada.bairro} onChange={handleEditChange} placeholder="Bairro" /></div>
                    <div className="empresas-form-row"><input type="text" name="morada.quarteirao" value={editFormData.morada.quarteirao} onChange={handleEditChange} placeholder="Quarteirão" /><input type="text" name="morada.casa" value={editFormData.morada.casa} onChange={handleEditChange} placeholder="Casa" /></div>
                    <div className="empresas-form-row"><input type="text" name="morada.cidade" value={editFormData.morada.cidade} onChange={handleEditChange} placeholder="Cidade" /><input type="text" name="morada.provincia" value={editFormData.morada.provincia} onChange={handleEditChange} placeholder="Província" /></div>
                    <div className="empresas-form-row"><input type="text" name="morada.distrito" value={editFormData.morada.distrito} onChange={handleEditChange} placeholder="Distrito" /><input type="text" name="morada.postoAdministrativo" value={editFormData.morada.postoAdministrativo} onChange={handleEditChange} placeholder="Posto Administrativo" /></div>
                    <div className="empresas-form-row"><select name="morada.pais" value={editFormData.morada.pais} onChange={handleEditChange}>{paises.map(p => <option key={p} value={p}>{p}</option>)}</select><input type="text" name="morada.codigoPostal" value={editFormData.morada.codigoPostal} onChange={handleEditChange} placeholder="Código Postal" /></div>
                    <div className="empresas-form-row">
                        <input type="text" placeholder="Latitude" value={editFormData.morada.coordenadas.latitude} onChange={(e) => setEditFormData(prev => ({ ...prev, morada: { ...prev.morada, coordenadas: { ...prev.morada.coordenadas, latitude: e.target.value } } }))} />
                        <input type="text" placeholder="Longitude" value={editFormData.morada.coordenadas.longitude} onChange={(e) => setEditFormData(prev => ({ ...prev, morada: { ...prev.morada, coordenadas: { ...prev.morada.coordenadas, longitude: e.target.value } } }))} />
                    </div>
                </div>
            );

        case 'contacto':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-form-group"><label>Email *</label><input type="email" name="email" value={editFormData.email} onChange={handleEditChange} required /></div>
                    <div className="empresas-form-row"><div className="empresas-form-group"><label>Telefone</label><input type="tel" name="telefone" value={editFormData.telefone} onChange={handleEditChange} /></div><div className="empresas-form-group"><label>Telefone Alternativo</label><input type="tel" name="telefoneAlternativo" value={editFormData.telefoneAlternativo} onChange={handleEditChange} /></div></div>
                    <div className="empresas-form-group"><label>WhatsApp</label><input type="tel" name="whatsapp" value={editFormData.whatsapp} onChange={handleEditChange} /></div>
                </div>
            );

        case 'financeiro':
            return (
                <div className="empresas-modal-section-financeiro">
                    <div className="empresas-form-subsection">
                        <h4>Moeda</h4>
                        <div className="empresas-form-row">
                            <input type="text" name="configuracoes.moeda.codigo" value={editFormData.configuracoes.moeda.codigo} onChange={handleEditChange} placeholder="Código" maxLength="3" />
                            <input type="text" name="configuracoes.moeda.simbolo" value={editFormData.configuracoes.moeda.simbolo} onChange={handleEditChange} placeholder="Símbolo" />
                            <input type="text" name="configuracoes.moeda.nome" value={editFormData.configuracoes.moeda.nome} onChange={handleEditChange} placeholder="Nome" />
                            <input type="number" name="configuracoes.moeda.casasDecimais" value={editFormData.configuracoes.moeda.casasDecimais} onChange={handleEditChange} min="0" max="4" />
                        </div>
                    </div>
                    <div className="empresas-form-subsection">
                        <h4>Formato de Números</h4>
                        <div className="empresas-form-row">
                            <select name="configuracoes.formatoNumero.separadorDecimal" value={editFormData.configuracoes.formatoNumero.separadorDecimal} onChange={handleEditChange}>
                                <option value=",">Vírgula (,)</option>
                                <option value=".">Ponto (.)</option>
                            </select>
                            <select name="configuracoes.formatoNumero.separadorMilhar" value={editFormData.configuracoes.formatoNumero.separadorMilhar} onChange={handleEditChange}>
                                <option value=".">Ponto (.)</option>
                                <option value=",">Vírgula (,)</option>
                                <option value=" ">Espaço ( )</option>
                            </select>
                        </div>
                    </div>
                </div>
            );

        case 'bancario':
            return renderEditDadosBancarios();

        case 'sistema':
            return (
                <div className="empresas-modal-section-sistema">
                    <div className="empresas-form-subsection">
                        <h4><Icon name="palette" size={16} /> Tema do Sistema</h4>
                        <div className="empresas-form-group">
                            <label>Cor Primária (Header)</label>
                            <div className="empresas-cores-grid">
                                {coresPreDefinidas.map((item) => {
                                    const isSelected = editFormData.configuracoes?.tema?.corPrimaria === item.cor;
                                    const isWhite = item.cor?.toUpperCase() === '#FFFFFF' || item.cor?.toLowerCase() === '#ffffff';
                                    const brilho = calcularBrilho(item.cor);

                                    return (
                                        <button
                                            key={item.cor}
                                            type="button"
                                            className={`empresas-cor-option ${isSelected ? 'selected' : ''}`}
                                            style={{
                                                backgroundColor: item.cor,
                                                border: isWhite ? '2px solid #e0e0e0' : isSelected ? '3px solid var(--apple-blue)' : '2px solid transparent',
                                                boxShadow: isSelected ? '0 0 0 2px var(--apple-blue)' : 'none'
                                            }}
                                            onClick={() => handleCorPrimariaChange(item.cor)}
                                            title={item.nome}
                                        >
                                            {isSelected && (
                                                <span className="empresas-cor-check" style={{ color: brilho < 128 ? '#ffffff' : '#1a1a2e' }}>✓</span>
                                            )}
                                            <span className="empresas-cor-tooltip">{item.nome}</span>
                                        </button>
                                    );
                                })}
                            </div>
                            <small className="empresas-form-hint">
                                <Icon name="info" size={12} style={{ marginRight: '4px' }} />
                                A cor primária é usada no header do sistema. As alterações são salvas automaticamente.
                            </small>
                        </div>
                    </div>
                </div>
            );

        case 'modulos':
            return (
                <div className="empresas-modal-section">
                    <div className="empresas-info-text" style={{ marginBottom: '1rem' }}>
                        <Icon name="info" size={14} /> Selecione os módulos disponíveis para esta empresa.
                        Os utilizadores só poderão aceder aos módulos ativos.
                    </div>
                    <div className="empresas-modulos-container">
                        {renderizarModulos(
                            editFormData.configuracoes?.modulosAtivos || {},
                            handleModuloChange,
                            setEditFormData,
                            editFormData
                        )}
                    </div>
                </div>
            );

        case 'plano':
            return renderPlanoTab();

        case 'licenca':
            return renderEditLicencaTab();

        default:
            return null;
    }
};

// ==============================================
// RENDERIZAÇÃO DA TAB DE LICENÇA (CRIAÇÃO)
// ==============================================
const renderLicencaTab = () => {
    return (
        <div className="empresas-modal-section">
            <div className="empresas-info-text" style={{ marginBottom: '1rem' }}>
                <Icon name="ticket" size={16} />
                Configure a licença da empresa. Os limites definidos aqui controlam o acesso dos utilizadores.
            </div>

            <div className="empresas-form-group">
                <label>Tipo de Licença / Plano</label>
                <select
                    name="plano.tipo"
                    value={formData.plano.tipo}
                    onChange={handleChange}
                    className="empresas-select-licenca"
                >
                    {tiposLicenca.map(p => <option key={p} value={p}>{p}</option>)}
                </select>
                <small className="empresas-form-hint">
                    O plano define as funcionalidades disponíveis para a empresa.
                </small>
            </div>

            <div className="empresas-form-row">
                <div className="empresas-form-group">
                    <label>Limite de Utilizadores</label>
                    <input
                        type="number"
                        name="plano.limiteUtilizadores"
                        value={formData.plano.limiteUtilizadores}
                        onChange={handleChange}
                        min="1"
                        className="empresas-input-licenca"
                    />
                    <small className="empresas-form-hint">
                        Número máximo de utilizadores que podem aceder à empresa.
                    </small>
                </div>
                <div className="empresas-form-group">
                    <label>Limite de Produtos</label>
                    <input
                        type="number"
                        name="plano.limiteProdutos"
                        value={formData.plano.limiteProdutos}
                        onChange={handleChange}
                        min="0"
                        className="empresas-input-licenca"
                    />
                    <small className="empresas-form-hint">
                        Número máximo de produtos que podem ser cadastrados.
                    </small>
                </div>
            </div>

            <div className="empresas-info-text empresas-info-text-box">
                <Icon name="info" size={12} />
                A licença será criada automaticamente após a empresa ser criada.
                Os limites podem ser alterados posteriormente na edição da empresa.
            </div>
        </div>
    );
};

// ==============================================
// RENDERIZAÇÃO DA TAB DE LICENÇA (EDIÇÃO)
// ==============================================
const renderEditLicencaTab = () => {
    if (!editFormData) return null;

    const licencaId = licencaData?.id || licencaData?._id;

    return (
        <div className="empresas-modal-section">
            {licencaMessage.text && (
                <div className={`empresas-modal-alert empresas-modal-alert-${licencaMessage.type}`}>
                    <Icon name={licencaMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                    <span>{licencaMessage.text}</span>
                    <button className="empresas-alert-close" onClick={() => setLicencaMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            <div className="empresas-licenca-info-header">
                <div className="empresas-licenca-status">
                    <span className="empresas-status-label">Status:</span>
                    {loadingLicenca ? (
                        <span className="empresas-status-loading">A carregar...</span>
                    ) : licencaData && licencaData.chave !== 'SEM-LICENCA' && licencaData.chave !== 'ERROR-LICENCA' ? (
                        <span className={`empresas-status-badge ${licencaData.ativa ? 'empresas-status-active' : 'empresas-status-suspended'}`}>
                            {licencaData.ativa ? 'Ativa' : 'Inativa'}
                        </span>
                    ) : (
                        <span className="empresas-status-badge empresas-status-pending">Sem licença</span>
                    )}
                </div>
                {licencaId && licencaData && licencaData.chave !== 'SEM-LICENCA' && licencaData.chave !== 'ERROR-LICENCA' && (
                    <button
                        className="empresas-btn-toggle-licenca"
                        onClick={toggleLicencaStatus}
                        disabled={loadingLicenca}
                        style={{
                            background: licencaData?.ativa ? 'var(--gradient-danger)' : 'var(--gradient-success)',
                        }}
                    >
                        {licencaData?.ativa ? 'Desativar' : 'Ativar'}
                    </button>
                )}
            </div>

            {loadingLicenca ? (
                <div className="empresas-loading-container">
                    <div className="empresas-spinner-small"></div> A carregar licença...
                </div>
            ) : (
                <div className="empresas-licenca-form">
                    {!isEditingLicenca ? (
                        <div className="empresas-licenca-details">
                            {licencaData && licencaData.chave && licencaData.chave !== 'SEM-LICENCA' && licencaData.chave !== 'ERROR-LICENCA' ? (
                                <>
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Chave:</span>
                                        <span className="empresas-detail-value empresas-detail-value-mono">{licencaData.chave}</span>
                                    </div>
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Plano:</span>
                                        <span className="empresas-detail-value">{licencaData.plano || 'Basico'}</span>
                                    </div>
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Tipo de Prazo:</span>
                                        <span className="empresas-detail-value">{licencaData.tipoPrazo || 'N/A'}</span>
                                    </div>
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Data de Início:</span>
                                        <span className="empresas-detail-value">{licencaData.dataInicio ? new Date(licencaData.dataInicio).toLocaleDateString('pt-PT') : 'N/A'}</span>
                                    </div>
                                    {licencaData.dataFim && (
                                        <div className="empresas-detail-row">
                                            <span className="empresas-detail-label">Data de Fim:</span>
                                            <span className="empresas-detail-value">{new Date(licencaData.dataFim).toLocaleDateString('pt-PT')}</span>
                                        </div>
                                    )}
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Limite Utilizadores:</span>
                                        <span className="empresas-detail-value">{licencaData.limiteUtilizadores || '-'}</span>
                                    </div>
                                    <div className="empresas-detail-row">
                                        <span className="empresas-detail-label">Limite Produtos:</span>
                                        <span className="empresas-detail-value">{licencaData.limiteProdutos || '-'}</span>
                                    </div>
                                    <button className="empresas-btn-edit-licenca" onClick={() => setIsEditingLicenca(true)}>
                                        <Icon name="edit" size={14} /> Editar Licença
                                    </button>
                                </>
                            ) : (
                                <div className="empresas-no-licenca">
                                    <p className="empresas-no-licenca-text">
                                        <Icon name="ticket" size={24} className="empresas-no-licenca-icon" />
                                        Nenhuma licença atribuída a esta empresa.
                                    </p>
                                    <button
                                        className="empresas-btn-create-licenca"
                                        onClick={() => {
                                            setEditLicencaData({
                                                chave: generateLicencaKey(),
                                                tipoPrazo: 'Mensal',
                                                dataFim: '',
                                                plano: 'Basico',
                                                limiteUtilizadores: 5,
                                                limiteProdutos: 100,
                                                ativa: true
                                            });
                                            setIsEditingLicenca(true);
                                        }}
                                    >
                                        <Icon name="add" size={14} /> Criar Licença
                                    </button>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="empresas-licenca-edit-form">
                            <div className="empresas-form-group">
                                <label>Chave da Licença</label>
                                <div className="empresas-chave-input-group">
                                    <input
                                        type="text"
                                        value={editLicencaData.chave}
                                        onChange={(e) => setEditLicencaData({ ...editLicencaData, chave: e.target.value })}
                                        readOnly
                                    />
                                    <button type="button" className="empresas-btn-nova-chave" onClick={gerarNovaChave}>
                                        <Icon name="refresh" size={14} /> Nova
                                    </button>
                                </div>
                            </div>
                            <div className="empresas-form-group">
                                <label>Plano</label>
                                <select value={editLicencaData.plano} onChange={(e) => setEditLicencaData({ ...editLicencaData, plano: e.target.value })}>
                                    {tiposLicenca.map(p => <option key={p} value={p}>{p}</option>)}
                                </select>
                            </div>
                            <div className="empresas-form-group">
                                <label>Tipo de Prazo</label>
                                <select value={editLicencaData.tipoPrazo} onChange={(e) => setEditLicencaData({ ...editLicencaData, tipoPrazo: e.target.value })}>
                                    <option value="Infinito">Infinito</option>
                                    <option value="DataFim">Data específica</option>
                                    <option value="Mensal">Mensal</option>
                                    <option value="Anual">Anual</option>
                                    <option value="Desativada">Desativada</option>
                                </select>
                            </div>
                            {editLicencaData.tipoPrazo === 'DataFim' && (
                                <div className="empresas-form-group">
                                    <label>Data de Fim</label>
                                    <input type="date" value={editLicencaData.dataFim} onChange={(e) => setEditLicencaData({ ...editLicencaData, dataFim: e.target.value })} />
                                </div>
                            )}
                            <div className="empresas-form-row">
                                <div className="empresas-form-group">
                                    <label>Limite Utilizadores</label>
                                    <input type="number" value={editLicencaData.limiteUtilizadores} onChange={(e) => setEditLicencaData({ ...editLicencaData, limiteUtilizadores: parseInt(e.target.value) || 0 })} min="0" />
                                </div>
                                <div className="empresas-form-group">
                                    <label>Limite Produtos</label>
                                    <input type="number" value={editLicencaData.limiteProdutos} onChange={(e) => setEditLicencaData({ ...editLicencaData, limiteProdutos: parseInt(e.target.value) || 0 })} min="0" />
                                </div>
                            </div>
                            <div className="empresas-form-group empresas-checkbox-group">
                                <label>
                                    <input type="checkbox" checked={editLicencaData.ativa} onChange={(e) => setEditLicencaData({ ...editLicencaData, ativa: e.target.checked })} />
                                    Licença Ativa
                                </label>
                            </div>
                            <div className="empresas-licenca-actions">
                                <button type="button" className="empresas-btn-licenca-save" onClick={salvarLicenca} disabled={loadingLicenca}>
                                    {loadingLicenca ? 'A guardar...' : 'Guardar Licença'}
                                </button>
                                <button
                                    type="button"
                                    className="empresas-btn-licenca-cancel"
                                    onClick={() => {
                                        setIsEditingLicenca(false);
                                        if (licencaData) {
                                            setEditLicencaData({
                                                chave: licencaData.chave || generateLicencaKey(),
                                                tipoPrazo: licencaData.tipoPrazo || 'Mensal',
                                                dataFim: licencaData.dataFim ? new Date(licencaData.dataFim).toISOString().split('T')[0] : '',
                                                plano: licencaData.plano || 'Basico',
                                                limiteUtilizadores: licencaData.limiteUtilizadores || 5,
                                                limiteProdutos: licencaData.limiteProdutos || 100,
                                                ativa: licencaData.ativa !== undefined ? licencaData.ativa : true
                                            });
                                        }
                                        setLicencaMessage({ text: '', type: '' });
                                    }}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

// ==============================================
// RENDERIZAÇÃO DOS DADOS BANCÁRIOS (CRIAÇÃO)
// ==============================================
const renderDadosBancarios = () => {
    return (
        <div className="empresas-modal-section-bancario">
            <div className="empresas-dados-bancarios-header">
                <p className="empresas-info-text">Estes dados serão utilizados em faturas, recibos e orçamentos</p>
                <button type="button" className="empresas-btn-add-bancario" onClick={addDadosBancarios}>
                    <Icon name="add" size={16} /> Adicionar Conta Bancária
                </button>
            </div>
            {formData.dadosBancarios.map((bancario, index) => (
                <div key={`bancario-${index}`} className="empresas-bancario-card">
                    <div className="empresas-bancario-header">
                        <h4>Conta Bancária {index + 1}</h4>
                        {index > 0 && (
                            <button type="button" className="empresas-btn-remove-bancario" onClick={() => removeDadosBancarios(index)}>
                                <Icon name="delete" size={16} /> Remover
                            </button>
                        )}
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Banco</label>
                            <select value={bancario.banco || ''} onChange={(e) => updateDadosBancarios(index, 'banco', e.target.value)}>
                                <option value="">Selecione o banco</option>
                                {bancos.map(b => <option key={b} value={b}>{b}</option>)}
                            </select>
                        </div>
                        <div className="empresas-form-group">
                            <label>Número da Conta</label>
                            <input type="text" placeholder="Número da Conta" value={bancario.conta || ''} onChange={(e) => updateDadosBancarios(index, 'conta', e.target.value)} />
                        </div>
                    </div>
                    <div className="empresas-form-group">
                        <label>Titular da Conta</label>
                        <input type="text" placeholder="Titular da Conta" value={bancario.titular || ''} onChange={(e) => updateDadosBancarios(index, 'titular', e.target.value)} />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>NIB</label>
                            <input type="text" placeholder="NIB" value={bancario.nib || ''} onChange={(e) => updateDadosBancarios(index, 'nib', e.target.value)} />
                        </div>
                        <div className="empresas-form-group">
                            <label>SWIFT/BIC</label>
                            <input type="text" placeholder="SWIFT/BIC" value={bancario.swift || ''} onChange={(e) => updateDadosBancarios(index, 'swift', e.target.value)} />
                        </div>
                    </div>
                    <div className="empresas-form-group empresas-checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                checked={bancario.principal || false}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setFormData(prev => ({
                                            ...prev,
                                            dadosBancarios: prev.dadosBancarios.map((b, i) => ({ ...b, principal: i === index }))
                                        }));
                                    } else {
                                        updateDadosBancarios(index, 'principal', false);
                                    }
                                }}
                            />
                            Conta Principal
                        </label>
                    </div>
                    {index < formData.dadosBancarios.length - 1 && <hr className="empresas-bancario-divider" />}
                </div>
            ))}
        </div>
    );
};

// ==============================================
// RENDERIZAÇÃO DOS DADOS BANCÁRIOS (EDIÇÃO)
// ==============================================
const renderEditDadosBancarios = () => {
    if (!editFormData) return null;
    const dadosBancarios = editFormData.dadosBancarios || [];
    return (
        <div className="empresas-modal-section-bancario">
            <div className="empresas-dados-bancarios-header">
                <p className="empresas-info-text">Estes dados serão utilizados em faturas, recibos e orçamentos</p>
                <button type="button" className="empresas-btn-add-bancario" onClick={addEditDadosBancarios}>
                    <Icon name="add" size={16} /> Adicionar Conta Bancária
                </button>
            </div>
            {dadosBancarios.map((bancario, index) => (
                <div key={`edit-bancario-${index}`} className="empresas-bancario-card">
                    <div className="empresas-bancario-header">
                        <h4>Conta Bancária {index + 1}</h4>
                        {dadosBancarios.length > 1 && (
                            <button type="button" className="empresas-btn-remove-bancario" onClick={() => removeEditDadosBancarios(index)}>
                                <Icon name="delete" size={16} /> Remover
                            </button>
                        )}
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>Banco</label>
                            <select value={bancario.banco || ''} onChange={(e) => updateEditDadosBancarios(index, 'banco', e.target.value)}>
                                <option value="">Selecione o banco</option>
                                {bancos.map(b => <option key={b} value={b}>{b}</option>)}
                            </select>
                        </div>
                        <div className="empresas-form-group">
                            <label>Número da Conta</label>
                            <input type="text" placeholder="Número da Conta" value={bancario.conta || ''} onChange={(e) => updateEditDadosBancarios(index, 'conta', e.target.value)} />
                        </div>
                    </div>
                    <div className="empresas-form-group">
                        <label>Titular da Conta</label>
                        <input type="text" placeholder="Titular da Conta" value={bancario.titular || ''} onChange={(e) => updateEditDadosBancarios(index, 'titular', e.target.value)} />
                    </div>
                    <div className="empresas-form-row">
                        <div className="empresas-form-group">
                            <label>NIB</label>
                            <input type="text" placeholder="NIB" value={bancario.nib || ''} onChange={(e) => updateEditDadosBancarios(index, 'nib', e.target.value)} />
                        </div>
                        <div className="empresas-form-group">
                            <label>SWIFT/BIC</label>
                            <input type="text" placeholder="SWIFT/BIC" value={bancario.swift || ''} onChange={(e) => updateEditDadosBancarios(index, 'swift', e.target.value)} />
                        </div>
                    </div>
                    <div className="empresas-form-group empresas-checkbox-group">
                        <label>
                            <input
                                type="checkbox"
                                checked={bancario.principal || false}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setEditFormData(prev => ({
                                            ...prev,
                                            dadosBancarios: prev.dadosBancarios.map((b, i) => ({ ...b, principal: i === index }))
                                        }));
                                    } else {
                                        updateEditDadosBancarios(index, 'principal', false);
                                    }
                                }}
                            />
                            Conta Principal
                        </label>
                    </div>
                    {index < dadosBancarios.length - 1 && <hr className="empresas-bancario-divider" />}
                </div>
            ))}
        </div>
    );
};

// ==============================================
// 🔥 RENDER PAGINAÇÃO - ESTILO PREMIUM
// ==============================================
const renderPagination = () => {
    const totalPages = pagination.pages || 1;
    const currentPage = pagination.page || 1;
    const totalItems = pagination.total || filteredEmpresas.length || 0;

    if (totalPages <= 1) return null;

    const startItem = (currentPage - 1) * pagination.limit + 1;
    const endItem = Math.min(currentPage * pagination.limit, totalItems);

    return (
        <div className="empresas-pagination">
            <div className="empresas-pagination-info">
                <span>Mostrando {startItem} - {endItem} de {totalItems} empresas</span>
            </div>
            <div className="empresas-pagination-controls">
                <button
                    className="empresas-pagination-btn"
                    onClick={() => {
                        if (currentPage > 1) {
                            setPagination({ ...pagination, page: currentPage - 1 });
                        }
                    }}
                    disabled={currentPage === 1}
                    title="Página anterior"
                >
                    <Icon name="chevron_left" size={18} />
                </button>

                <div className="empresas-pagination-numbers">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
                        if (
                            page === 1 ||
                            page === totalPages ||
                            (page >= currentPage - 2 && page <= currentPage + 2)
                        ) {
                            return (
                                <button
                                    key={page}
                                    className={`empresas-pagination-number ${currentPage === page ? 'active' : ''}`}
                                    onClick={() => setPagination({ ...pagination, page })}
                                >
                                    {page}
                                </button>
                            );
                        }
                        if (
                            (page === currentPage - 3 && page > 2) ||
                            (page === currentPage + 3 && page < totalPages - 1)
                        ) {
                            return <span key={page} className="empresas-pagination-ellipsis">…</span>;
                        }
                        return null;
                    })}
                </div>

                <button
                    className="empresas-pagination-btn"
                    onClick={() => {
                        if (currentPage < totalPages) {
                            setPagination({ ...pagination, page: currentPage + 1 });
                        }
                    }}
                    disabled={currentPage === totalPages}
                    title="Próxima página"
                >
                    <Icon name="chevron_right" size={18} />
                </button>
            </div>
        </div>
    );
};

// ==============================================
// RENDER PRINCIPAL
// ==============================================
return (
    <div className="empresas-container">
        {/* MODAL DE CRIAÇÃO DE EMPRESA */}
        {showCreateModal && (
            <div className="empresas-modal-overlay" onClick={() => { setShowCreateModal(false); resetForm(); }}>
                <div className="empresas-modal-content empresas-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header">
                        <h3><Icon name="apartment" size={22} /> Criar Nova Empresa</h3>
                        <button className="empresas-modal-close" onClick={() => { setShowCreateModal(false); resetForm(); }}>×</button>
                    </div>
                    <div className="empresas-modal-tabs-container">
                        <div className="empresas-modal-tabs">
                            {modalTabs.map(tab => (
                                <button
                                    key={tab.id}
                                    className={`empresas-modal-tab ${activeModalTab === tab.id ? 'active' : ''}`}
                                    onClick={() => setActiveModalTab(tab.id)}
                                >
                                    <Icon name={tab.icon} size={18} /><span>{tab.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="empresas-modal-body">
                        {createMessage.text && (
                            <div className={`empresas-modal-alert empresas-modal-alert-${createMessage.type}`}>
                                <Icon name={createMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                                <span>{createMessage.text}</span>
                                <button className="empresas-alert-close" onClick={() => setCreateMessage({ text: '', type: '' })}>×</button>
                            </div>
                        )}
                        <form onSubmit={handleCreateSubmit}>
                            <div className="empresas-modal-scroll-area">
                                {renderTabContent()}
                            </div>
                            <div className="empresas-modal-actions">
                                <button type="submit" className="empresas-modal-btn-primary" disabled={createLoading}>
                                    {createLoading ? 'A criar...' : 'Criar Empresa'}
                                </button>
                                <button type="button" className="empresas-modal-btn-secondary" onClick={resetForm}>Limpar tudo</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* MODAL DE EDIÇÃO DE EMPRESA */}
        {showEditModal && editFormData && (
            <div className="empresas-modal-overlay" onClick={() => setShowEditModal(false)}>
                <div className="empresas-modal-content empresas-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header">
                        <h3><Icon name="edit" size={22} /> Editar Empresa: {selectedEmpresa?.nome}</h3>
                        <button className="empresas-modal-close" onClick={() => setShowEditModal(false)}>×</button>
                    </div>
                    <div className="empresas-modal-tabs-container">
                        <div className="empresas-modal-tabs">
                            {modalTabs.map(tab => (
                                <button
                                    key={tab.id}
                                    className={`empresas-modal-tab ${activeModalTab === tab.id ? 'active' : ''}`}
                                    onClick={() => setActiveModalTab(tab.id)}
                                >
                                    <Icon name={tab.icon} size={18} /><span>{tab.label}</span>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="empresas-modal-body">
                        {editMessage.text && (
                            <div className={`empresas-modal-alert empresas-modal-alert-${editMessage.type}`}>
                                <Icon name={editMessage.type === 'success' ? 'check_circle' : 'error'} size={18} />
                                <span>{editMessage.text}</span>
                                <button className="empresas-alert-close" onClick={() => setEditMessage({ text: '', type: '' })}>×</button>
                            </div>
                        )}
                        <form onSubmit={handleEditSubmit}>
                            <div className="empresas-modal-scroll-area">
                                {renderEditTabContent()}
                            </div>
                            <div className="empresas-modal-actions">
                                <button type="submit" className="empresas-modal-btn-primary" disabled={editLoading}>
                                    {editLoading ? 'A atualizar...' : 'Salvar Alterações'}
                                </button>
                                <button type="button" className="empresas-modal-btn-secondary" onClick={resetEditForm}>Restaurar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* MODAL DE GESTÃO DE UTILIZADORES */}
        {showUsersModal && selectedEmpresa && (
            <div className="empresas-modal-overlay" onClick={() => setShowUsersModal(false)}>
                <div className="empresas-modal-content empresas-users-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header">
                        <h3><Icon name="people" size={22} /> Utilizadores da Empresa</h3>
                        <div className="empresas-modal-header-info">
                            <span className="empresas-empresa-name">{selectedEmpresa.nome}</span>
                            {selectedEmpresa.arquivado && (
                                <span className="empresas-empresa-status-archived">
                                    <Icon name="archive" size={14} /> Arquivada
                                </span>
                            )}
                        </div>
                        <button className="empresas-modal-close" onClick={() => setShowUsersModal(false)}>×</button>
                    </div>
                    <div className="empresas-modal-body">
                        <div className="empresas-users-add-section">
                            <h4><Icon name="person_add" size={16} /> Adicionar Utilizador</h4>

                            <div className="empresas-users-limite-info">
                                <div className="empresas-users-limite-status">
                                    <span className="empresas-users-limite-label">Utilizadores:</span>
                                    <span className="empresas-users-limite-valor">
                                        {loadingLimite ? (
                                            <span className="empresas-status-loading">A carregar...</span>
                                        ) : (
                                            <>{limiteUtilizadores.utilizadoresAtuais || 0} / {limiteUtilizadores.limite || '∞'}</>
                                        )}
                                    </span>
                                    {!loadingLimite && limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0 && (
                                        <span className="empresas-users-limite-alerta"><Icon name="warning" size={14} /> Limite atingido!</span>
                                    )}
                                    {!loadingLimite && limiteUtilizadores.disponivel > 0 && limiteUtilizadores.limite > 0 && (
                                        <span className="empresas-users-limite-disponivel">{limiteUtilizadores.disponivel} vaga(s) disponível(eis)</span>
                                    )}
                                    {!loadingLimite && limiteUtilizadores.limite === 0 && (
                                        <span className="empresas-users-limite-sem-licenca"><Icon name="info" size={14} /> Sem licença ativa</span>
                                    )}
                                </div>
                            </div>

                            {usersModalMessage.text && (
                                <div className={`empresas-users-modal-alert empresas-users-modal-alert-${usersModalMessage.type}`}>
                                    <Icon name={usersModalMessage.type === 'success' ? 'check_circle' : 'error'} size={16} />
                                    <span>{usersModalMessage.text}</span>
                                    <button className="empresas-alert-close" onClick={() => setUsersModalMessage({ text: '', type: '' })}>×</button>
                                </div>
                            )}

                            <div className="empresas-add-user-form">
                                <select
                                    value={selectedUserToAdd}
                                    onChange={(e) => setSelectedUserToAdd(e.target.value)}
                                    className="empresas-user-select"
                                    disabled={selectedEmpresa.arquivado || (limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0)}
                                >
                                    <option value="">Selecione um utilizador...</option>
                                    {availableUsers.map(user => (
                                        <option key={user._id} value={user._id}>{user.nome} - {user.email}</option>
                                    ))}
                                </select>
                                <button
                                    onClick={adicionarUtilizadorEmpresa}
                                    className="empresas-btn-add-user"
                                    disabled={loadingUsers || !selectedUserToAdd || selectedEmpresa.arquivado || (limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0)}
                                >
                                    <Icon name="add" size={16} /> Adicionar
                                </button>
                            </div>
                            {selectedEmpresa.arquivado && (
                                <p className="empresas-warning-text"><Icon name="warning" size={12} /> Empresa arquivada. Não é possível adicionar novos utilizadores.</p>
                            )}
                            {!loadingLimite && limiteUtilizadores.disponivel <= 0 && limiteUtilizadores.limite > 0 && (
                                <p className="empresas-warning-text empresas-warning-text-danger">
                                    <Icon name="warning" size={12} /> Limite de utilizadores atingido! Contacte o administrador para aumentar o limite da licença.
                                </p>
                            )}
                        </div>
                        <div className="empresas-users-list-section">
                            <h4><Icon name="people" size={16} /> Utilizadores Associados ({empresaUsers.length})</h4>
                            {loadingUsers ? (
                                <div className="empresas-loading-users"><div className="empresas-spinner-small"></div> Carregando...</div>
                            ) : empresaUsers.length === 0 ? (
                                <div className="empresas-empty-users"><Icon name="people_outline" size={32} /><p>Nenhum utilizador associado a esta empresa</p></div>
                            ) : (
                                <div className="empresas-users-table-container">
                                    <table className="empresas-users-table">
                                        <thead>
                                            <tr><th>Utilizador</th><th>Email</th><th>Admin</th><th>Data Associação</th><th>Ações</th></tr>
                                        </thead>
                                        <tbody>
                                            {empresaUsers.map(user => {
                                                const userIdForToggle = user.userId || user._id;
                                                const isSuperadmin = isUserSuperAdmin(user);
                                                const isAdmin = user.isAdmin || false;

                                                return (
                                                    <tr key={user._id || user.userId} className={!user.isActive ? 'empresas-user-inactive' : ''}>
                                                        <td>
                                                            <div className="empresas-user-info">
                                                                <div className="empresas-user-avatar">
                                                                    <UserAvatar user={user} getImagemUrl={getImagemUrl} />
                                                                </div>
                                                                <strong>{user.nome}</strong>
                                                                {!user.isActive && (
                                                                    <span className="empresas-user-status-inactive">
                                                                        <Icon name="block" size={12} /> Inativo
                                                                    </span>
                                                                )}
                                                                {isSuperadmin && (
                                                                    <span className="empresas-user-status-superadmin">
                                                                        <Icon name="shield" size={12} /> Superadmin
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td>{user.email}</td>
                                                        <td>
                                                            {isSuperadmin ? (
                                                                <span className="empresas-user-status-superadmin empresas-user-status-superadmin-sm">
                                                                    <Icon name="shield" size={11} /> Superadmin
                                                                </span>
                                                            ) : (
                                                                <label className="empresas-admin-toggle">
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={isAdmin}
                                                                        onChange={(e) => atualizarAdminEmpresa(userIdForToggle, e.target.checked)}
                                                                    />
                                                                    <span className="empresas-toggle-slider"></span>
                                                                    <span className="empresas-toggle-label">
                                                                        {isAdmin ? 'Admin' : 'Utilizador'}
                                                                    </span>
                                                                </label>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <div className="empresas-date-cell">
                                                                {user.associadoEm ? (
                                                                    <>
                                                                        <span className="empresas-date-main">
                                                                            {new Date(user.associadoEm).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' })}
                                                                        </span>
                                                                        <span className="empresas-date-separator"></span>
                                                                        <span className="empresas-date-year">
                                                                            {new Date(user.associadoEm).getFullYear()}
                                                                        </span>
                                                                    </>
                                                                ) : '-'}
                                                            </div>
                                                        </td>
                                                        <td>
                                                            {isSuperadmin ? (
                                                                <span className="empresas-protegido-text">Protegido</span>
                                                            ) : (
                                                                <button
                                                                    className="empresas-btn-remove-user"
                                                                    onClick={() => openConfirmRemoveUserModal(user)}
                                                                    title="Remover da empresa"
                                                                >
                                                                    <Icon name="delete" size={16} />
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="empresas-modal-actions">
                        <button type="button" className="empresas-modal-btn-secondary" onClick={() => setShowUsersModal(false)}>Fechar</button>
                    </div>
                </div>
            </div>
        )}

        {/* MODAL DE CONFIRMAÇÃO DE REMOÇÃO DE UTILIZADOR */}
        {showConfirmRemoveUserModal && userToRemove && (
            <div className="empresas-modal-overlay" onClick={closeConfirmRemoveUserModal}>
                <div className="empresas-modal-remocao-utilizador empresas-modal-confirm" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header">
                        <h3>
                            <span className="empresas-header-icon">⚠️</span>
                            Confirmar Remoção
                        </h3>
                        <button className="empresas-modal-close" onClick={closeConfirmRemoveUserModal}>×</button>
                    </div>
                    <div className="empresas-modal-body">
                        <div className="empresas-user-remove-avatar">
                            <div className="empresas-user-remove-avatar-circle">
                                <UserAvatar user={userToRemove} getImagemUrl={getImagemUrl} />
                            </div>
                        </div>
                        <h4>Remover utilizador da empresa?</h4>
                        <p>
                            Tem certeza que deseja remover <strong>{userToRemove.nome} </strong>
                            da empresa <strong>{selectedEmpresa?.nome}</strong>?
                        </p>
                        <p className="empresas-confirm-subtext">
                            <Icon name="info" size={14} />
                            O utilizador perderá o acesso a esta empresa.
                            {userToRemove.isAdmin && ' Este utilizador é administrador da empresa.'}
                        </p>
                    </div>
                    <div className="empresas-modal-actions-footer">
                        <button className="empresas-btn-confirm-danger" onClick={confirmRemoveUser} disabled={removingUser}>
                            {removingUser ? (
                                <><span className="empresas-spinner-small"></span> A remover...</>
                            ) : (
                                <><Icon name="delete" size={16} /> Remover Utilizador</>
                            )}
                        </button>
                        <button className="empresas-btn-cancel" onClick={closeConfirmRemoveUserModal} disabled={removingUser}>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* MODAL DE ALERTA PARA SUPERADMIN */}
        {showSuperAdminWarningModal && superAdminToRemove && (
            <div className="empresas-modal-overlay" onClick={() => setShowSuperAdminWarningModal(false)}>
                <div className="empresas-modal-content empresas-modal-confirm empresas-modal-danger" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header empresas-modal-header-danger">
                        <h3>
                            <span className="empresas-header-icon">🚨</span>
                            Ação Crítica - Superadmin
                        </h3>
                        <button className="empresas-modal-close" onClick={() => setShowSuperAdminWarningModal(false)}>×</button>
                    </div>
                    <div className="empresas-modal-body">
                        <div className="empresas-user-remove-avatar">
                            <div className="empresas-user-remove-avatar-circle empresas-superadmin-avatar">
                                <UserAvatar user={superAdminToRemove} getImagemUrl={getImagemUrl} />
                            </div>
                        </div>

                        <h4 className="empresas-superadmin-titulo">
                            ⚠️ ATENÇÃO: Último Superadmin!
                        </h4>

                        <div className="empresas-superadmin-warning-box">
                            <p className="empresas-superadmin-warning-text">
                                <Icon name="warning" size={20} className="empresas-superadmin-warning-icon" />
                                Está prestes a remover o <strong>ÚNICO Superadmin</strong> da empresa!
                            </p>
                            <p className="empresas-superadmin-warning-subtext">
                                <strong>{superAdminToRemove.nome}</strong> é o único utilizador com permissões de Superadmin nesta empresa.
                            </p>
                        </div>

                        <div className="empresas-superadmin-consequences">
                            <p className="empresas-superadmin-consequences-title">⚠️ Consequências desta ação:</p>
                            <ul className="empresas-superadmin-consequences-list">
                                <li>❌ A empresa ficará <strong>SEM Superadmin</strong></li>
                                <li>❌ Ninguém poderá gerir permissões de administradores</li>
                                <li>❌ Não será possível adicionar novos Superadmins</li>
                                <li>❌ Apenas um Superadmin global poderá resolver esta situação</li>
                            </ul>
                        </div>

                        <div className="empresas-superadmin-warning-actions">
                            <p className="empresas-superadmin-recomendacao">
                                <Icon name="info" size={16} className="empresas-superadmin-recomendacao-icon" />
                                Recomendação: Adicione outro Superadmin antes de remover este.
                            </p>
                        </div>

                        <p className="empresas-confirm-subtext empresas-confirm-subtext-danger">
                            <Icon name="lock" size={14} /> Esta ação é <strong>irreversível</strong> e só pode ser desfeita por um Superadmin global.
                        </p>
                    </div>
                    <div className="empresas-modal-actions">
                        <button
                            className="empresas-btn-confirm-danger empresas-btn-danger-large"
                            onClick={() => {
                                if (window.confirm('⚠️ Tem a certeza absoluta que deseja remover o ÚNICO Superadmin? Esta ação é IRREVERSÍVEL!')) {
                                    setUserToRemove(superAdminToRemove);
                                    setShowSuperAdminWarningModal(false);
                                    setShowConfirmRemoveUserModal(true);
                                }
                            }}
                            disabled={removingUser}
                        >
                            {removingUser ? (
                                <><span className="empresas-spinner-small"></span> A processar...</>
                            ) : (
                                <><Icon name="delete_forever" size={20} /> Remover Mesmo Assim (Irreversível)</>
                            )}
                        </button>
                        <button
                            className="empresas-btn-confirm-success"
                            onClick={() => {
                                setShowSuperAdminWarningModal(false);
                                setUsersModalMessage({
                                    text: '💡 Recomenda-se adicionar outro Superadmin antes de remover este.',
                                    type: 'warning'
                                });
                            }}
                        >
                            <Icon name="person_add" size={18} /> Adicionar Superadmin
                        </button>
                        <button className="empresas-btn-cancel" onClick={() => setShowSuperAdminWarningModal(false)}>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        )}

        {/* MODAL DE CONFIRMAÇÃO DE EXCLUSÃO */}
        {showDeleteModal && empresaToDelete && (
            <div className="empresas-modal-overlay" onClick={closeDeleteModal}>
                <div className="empresas-modal-exclusoes empresas-modal-confirm" onClick={(e) => e.stopPropagation()}>
                    <div className="empresas-modal-header">
                        <h3>
                            <span className="empresas-header-icon">⚠️</span>
                            Confirmar Ação
                        </h3>
                        <button className="empresas-modal-close" onClick={closeDeleteModal}>×</button>
                    </div>
                    <div className="empresas-modal-body">
                        <div className="empresas-confirm-icon empresas-confirm-icon-warning">
                            <Icon name="warning" size={32} />
                        </div>
                        <h4>O que deseja fazer com a empresa <strong>{empresaToDelete.nome}</strong>?</h4>
                        <p>Esta ação irá arquivar a empresa ou eliminá-la permanentemente do sistema.</p>
                        <p className="empresas-confirm-subtext">
                            <Icon name="info" size={14} />
                            {empresaToDelete.arquivado
                                ? 'A empresa já está arquivada. A eliminação permanente removerá todos os dados.'
                                : 'Arquivar irá desativar a empresa e os seus utilizadores. A eliminação permanente é irreversível.'}
                        </p>
                    </div>
                    <div className="empresas-modal-actions-footer">
                        <button className="empresas-btn-confirm-warning" onClick={confirmArchive} disabled={deleting}>
                            {deleting ? (
                                <><span className="empresas-spinner-small"></span> A processar...</>
                            ) : (
                                <><Icon name="archive" size={16} /> Arquivar</>
                            )}
                        </button>
                        <button className="empresas-btn-confirm-danger" onClick={confirmDeletePermanent} disabled={deleting}>
                            {deleting ? (
                                <><span className="empresas-spinner-small"></span> A processar...</>
                            ) : (
                                <><Icon name="delete_forever" size={16} /> Eliminar</>
                            )}
                        </button>
                        <button className="empresas-btn-cancel" onClick={closeDeleteModal} disabled={deleting}>
                            Cancelar
                        </button>
                    </div>
                </div>
            </div>
        )}
    
            {/* HEADER */}
            <div className="empresas-header">
                <div className="header-title">
                    <h2><Icon name="apartment" size={24} /> Gestão de Empresas</h2>
                    <p>Gerencie todas as empresas cadastradas no sistema</p>
                </div>
                <button className="btn-create" onClick={() => setShowCreateModal(true)}><Icon name="add" size={18} /> Nova Empresa</button>
            </div>

            {/* MENSAGENS */}
            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    <Icon name={message.type === 'success' ? 'check_circle' : 'error'} size={16} />
                    <span>{message.text}</span>
                    <button className="alert-close" onClick={() => setMessage({ text: '', type: '' })}>×</button>
                </div>
            )}

            {/* FILTROS */}
            <div className="empresas-filters">
                <div className="search-box">
                    <Icon name="search" size={18} />
                    <input
                        type="text"
                        placeholder="Pesquisar por nome, email, NUIT ou CAFE..."
                        value={searchTerm || ''}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    {searchTerm && (
                        <button className="search-clear" onClick={() => setSearchTerm('')}>
                            <Icon name="close" size={16} />
                        </button>
                    )}
                </div>
                <div className="filter-group">
                    <select value={filtroStatus} onChange={(e) => setFiltroStatus(e.target.value)}>
                        <option value="todos">Todos os Status</option>
                        {statusOptions.map(s => <option key={s} value={s}>{s === 'EmAprovacao' ? 'Em Aprovação' : s}</option>)}
                    </select>
                    <select value={filtroPlano} onChange={(e) => setFiltroPlano(e.target.value)}>
                        <option value="todos">Todos os Planos</option>
                        {tiposPlano.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                    <button className="btn-refresh" onClick={carregarEmpresasComForca} title="Atualizar"><Icon name="refresh" size={18} /></button>
                </div>
            </div>

            {/* ESTATÍSTICAS */}
            <div className="empresas-stats">
                <div className="stat-card"><div className="stat-icon total"><Icon name="apartment" size={20} /></div><div className="stat-info"><span className="stat-value">{pagination.total}</span><span className="stat-label">Total</span></div></div>
                <div className="stat-card"><div className="stat-icon active"><Icon name="check_circle" size={20} /></div><div className="stat-info"><span className="stat-value">{empresas.filter(e => e.status === 'Ativa' && !e.arquivado).length}</span><span className="stat-label">Ativas</span></div></div>
                <div className="stat-card"><div className="stat-icon suspended"><Icon name="warning" size={20} /></div><div className="stat-info"><span className="stat-value">{empresas.filter(e => e.status === 'Suspensa' || e.status === 'Cancelada' || e.arquivado).length}</span><span className="stat-label">Inativas</span></div></div>
                <div className="stat-card"><div className="stat-icon pending"><Icon name="pending" size={20} /></div><div className="stat-info"><span className="stat-value">{empresas.filter(e => e.status === 'EmAprovacao').length}</span><span className="stat-label">Pendentes</span></div></div>
            </div>

            {/* TABELA */}
            {loading ? (
                <div className="loading-container"><div className="spinner-large"></div><p>A carregar empresas...</p></div>
            ) : (
                <div className="empresas-table-container">
                    <table className="empresas-table">
                        <thead>
                            <tr>
                                <th className="col-logo">Imagem</th>
                                <th className="col-empresa">Empresa</th>
                                <th className="col-contacto">Contacto</th>
                                <th className="col-nuit">NUIT</th>
                                <th className="col-plano">Plano</th>
                                <th className="col-status">Status</th>
                                <th className="col-data">Criação</th>
                                <th className="col-acoes">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredEmpresas.length === 0 ? (
                                <tr className="empty-row">
                                    <td colSpan="8">
                                        <div className="empty-state">
                                            <Icon name="apartment" size={48} />
                                            <p>Nenhuma empresa encontrada</p>
                                            <button className="btn-create-small" onClick={() => setShowCreateModal(true)}>
                                                Criar primeira empresa
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                filteredEmpresas
                                    .slice((pagination.page - 1) * pagination.limit, pagination.page * pagination.limit)
                                    .map(empresa => (
                                        <tr key={empresa._id} className={empresa.arquivado ? 'empresa-arquivada' : ''}>
                                            <td className="logo-cell">
                                                <EmpresaImage empresa={empresa} getImagemUrl={getImagemUrl} />
                                            </td>
                                            <td>
                                                <div className="empresa-info">
                                                    <strong>{empresa.nome}</strong>
                                                    {empresa.nomeCurto && <small>{empresa.nomeCurto}</small>}
                                                    {empresa.arquivado && (
                                                        <span className="arquivado-badge">
                                                            <Icon name="archive" size={12} /> Arquivado
                                                        </span>
                                                    )}
                                                    {empresa.utilizadores > 0 && (
                                                        <span className="users-count">
                                                            <Icon name="people" size={10} /> {empresa.utilizadores}
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="contact-info">
                                                    <span><Icon name="email" size={12} /> {empresa.email}</span>
                                                    {empresa.telefone && <span><Icon name="phone" size={12} /> {empresa.telefone}</span>}
                                                </div>
                                            </td>
                                            <td>{empresa.nuit || '-'}</td>
                                            <td>{getPlanoBadge(empresa)}</td>
                                            <td>{getStatusBadge(empresa.status)}</td>
                                            <td>
                                                <div className="date-cell">
                                                    {empresa.criadoEm ? (
                                                        <>
                                                            <span className="date-main">
                                                                {new Date(empresa.criadoEm).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' })}
                                                            </span>
                                                            <span className="date-separator"></span>
                                                            <span className="date-year">
                                                                {new Date(empresa.criadoEm).getFullYear()}
                                                            </span>
                                                        </>
                                                    ) : '-'}
                                                </div>
                                            </td>
                                            <td className="actions-cell">
                                                <button className="action-btn edit" onClick={() => handleEdit(empresa)} title="Editar">
                                                    <Icon name="edit" size={16} />
                                                </button>
                                                <button className="action-btn users" onClick={() => openUsersModal(empresa)} title="Gerir Utilizadores">
                                                    <Icon name="people" size={16} />
                                                </button>
                                                <button className="action-btn delete" onClick={() => openDeleteModal(empresa)} title="Excluir">
                                                    <Icon name="delete" size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                            )}
                        </tbody>
                    </table>

                    {/* 🔥 PAGINAÇÃO */}
                    {renderPagination()}
                </div>
            )}
        </div>
    );
}